<template>
  <div>
    <v-container fluid>
      <h2 class="heading-text">Chat Logs</h2>
      <div class="mt-2 mb-4">
        <hr />
      </div>

      <!-- Date Range Filter Card -->
      <div class="reportdata-filters-wrapper">
        <!-- Filter Row -->
        <div class="reportdata-filter-card">
          <div class="reportdata-filter-header">
            <img src="@/assets/material-symbols_arrow-range-rounded.svg" alt="Date range" width="20" height="20" />
            <span class="reportdata-filter-title">Date Range</span>
          </div>
          <v-row class="items-center justify-between mt-2">
            <!-- Start Date -->
            <v-col cols="12" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="Start Date" class="text-sm font-medium text-gray-700">
                  Start Date
                </label>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                      style="cursor: pointer; margin-left: 4px;" />
                  </template>
                  <span>Select start date for filtering.</span>
                </v-tooltip>
              </div>
              <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition"
                location="bottom" min-width="auto">
                <template #activator="{ props }">
                  <v-text-field v-model="startDate" placeholder="Select Date" readonly variant="outlined" v-bind="props"
                    density="compact" class="reportdata-field-date mt-1" clearable @click:clear="clearStartDate"
                    hide-details>
                    <template #prepend-inner>
                      <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="startDate" :key="`start-${startPickerYear}-${startPickerMonth}`"
                  :year="startPickerYear" :month="startPickerMonth" @update:year="startPickerYear = $event"
                  @update:month="startPickerMonth = $event" :max="new Date().toISOString().substr(0, 10)"
                  @update:model-value="
                    (val) => {
                      startDate = formatDate(val);
                      startDateFlag = false;
                    }
                  " show-adjacent-months class="date-picker">
                  <template #header>
                    <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                      <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(startPickerYear,
                        startPickerMonth, startDate) }}</div>
                      <v-select v-model="startPickerYear" :items="years" density="compact" variant="plain" hide-details
                        class="month-year-select" style="width: 100px;"></v-select>
                    </div>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-col>

            <div class="date-divider">-</div>

            <!-- End Date -->
            <v-col cols="12" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="End Date" class="text-sm font-medium text-gray-700">
                  End Date
                </label>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                      style="cursor: pointer; margin-left: 4px;" />
                  </template>
                  <span>Select end date for filtering.</span>
                </v-tooltip>
              </div>
              <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition"
                location="bottom" min-width="auto">
                <template #activator="{ props }">
                  <v-text-field v-model="endDate" placeholder="Select date" readonly variant="outlined" v-bind="props"
                    density="compact" class="reportdata-field-date mt-1" clearable @click:clear="clearEndDate"
                    hide-details>
                    <template #prepend-inner>
                      <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="endDate" :key="`end-${endPickerYear}-${endPickerMonth}`" :year="endPickerYear"
                  :month="endPickerMonth" @update:year="endPickerYear = $event" @update:month="endPickerMonth = $event"
                  :min="startDate != null ? startDate : null" @update:model-value="
                    (val) => {
                      endDate = formatDate(val);
                      endDateFlag = false;
                    }
                  " color="#C32E0E" class="date-picker">
                  <template #header>
                    <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                      <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(endPickerYear, endPickerMonth,
                        endDate) }}</div>
                      <v-select v-model="endPickerYear" :items="years" density="compact" variant="plain" hide-details
                        class="month-year-select" style="max-width: 90px;"></v-select>
                    </div>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="1" md="1" class="dashboard-search-col">
                  <div class="mt-8">
                    <button type="button" @click="Search" class="search-btn">
                      <img src="@/assets/search.svg" alt="img" width="18" height="18" style="margin-top: 6px;">
                    </button>
                  </div>
                </v-col>
            <!-- Advanced Filters Toggle -->
            <v-col class="d-flex align-center justify-start mt-8 divider" style="gap: 12px;">
              <img :src="images.chatlog" alt="filter" width="20" height="20" style="color: #C32E0E;" />
              <span style="color: #C32E0E; font-weight: 500; font-size: 14px;">{{ $t("AdvancedFilters") }}</span>
              <v-switch v-model="detailsExpanded" class="memory-switch ml-2" hide-details density="compact"></v-switch>
            </v-col>
            
            <!-- Process Prompt-->
            <!-- <v-col cols="12" md="3" class="d-flex flex-column ml-auto">
              <div class="d-flex align-start mb-1" style="gap: 2px">
                <label for="Log Type" class="text-sm font-medium text-gray-700">
                  Log Type
                </label>
                <v-tooltip location="top" max-width="400px">
                  <template v-slot:activator="{ props }">
                    <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                      style="cursor: pointer; margin-left: 4px;" />
                  </template>
                  <ul class="ml-3" style="padding-left: 0; list-style-position: inside;">
                    <li>Token Usage: Checking the number of tokens used.</li>
                    <li>Raw Log: All logs.</li>
                    <li>Memory Debugger: Memory data stored in each question and answer session.</li>
                  </ul>
                </v-tooltip>
              </div>
              <v-select :items="type_options" item-title="name" item-value="value" placeholder="Choose Type"
                persistent-placeholder variant="plain" density="compact" color="primary" v-model="type"
                hide-details="auto" class="logType-select-input" style="padding: 0 8px;">
              </v-select>
            </v-col> -->
          </v-row>
          <v-expand-transition>
            <v-row v-show="detailsExpanded" class="mt-4 advanced-filters-row">
              <v-col cols="12">
                <div class="reportdata-filter-header">
                <img :src="images.chatlog" alt="advanced filters" width="20" height="20" />
                <span class="reportdata-filter-title">Advance Filters</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="User Channel" class="text-sm font-medium text-gray-700">
                    User Channel
                  </label>
                  <v-tooltip location="top" max-width="320px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                        style="cursor: pointer; margin-left: 4px;" />
                    </template>
                    <span>Enter the specific user ID or username that uniquely identifies this individual across all chats.</span>
                  </v-tooltip>
                </div>
                <v-text-field v-model="userChannel" placeholder="Enter User Channel" clearable variant="plain" density="compact"
                  color="grey" class="date-style" style="padding: 0 8px;" hide-details />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="Session ID" class="text-sm font-medium text-gray-700">
                    Session ID
                  </label>
                  <v-tooltip location="top" max-width="320px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                        style="cursor: pointer; margin-left: 4px;" />
                    </template>
                    <span>A unique ID that helps identify this chat session.</span>
                  </v-tooltip>
                </div>
                <v-text-field v-model="sessionID" placeholder="Enter Session ID" clearable variant="plain" density="compact"
                  color="grey" class="date-style" style="padding: 0 8px;" hide-details />
              </v-col>

              <v-col cols="12" sm="12" md="4" class="d-flex align-end gap-2">
                <button type="button" @click="applyFilter" class="search-btn-new" style="min-width: 130px;">
                  <span>Apply Filter</span>
                </button>
                <button type="button" @click="clearFilters" class="clear-filters-btn">
                  <img src="@/assets/charm_cross.svg" alt="img" width="18" height="18" />
                  <span>Clear All Filters</span>
                </button>
              </v-col>
            </v-row>
          </v-expand-transition>
        </div>
      </div>

      <!-- Advanced Filters Section (Expandable) -->
      <!-- <v-card class="advanced-filter-expandable-card mt-4" elevation="0">
        <div :class="['expandable-card-header mt-4', { 'expandable-card-header-expanded': detailsExpanded }]"
          elevation="0" @click="detailsExpanded = !detailsExpanded" role="button" :aria-expanded="detailsExpanded"
          tabindex="0">
          <div class="header-left">
            <v-icon :color="detailsExpanded ? '#ffffff' : '#C32E0E'" size="30">mdi-filter-variant</v-icon>
            <span class="font-weight-bold">{{ $t("AdvancedFilters") }}</span>
          </div>
          <v-btn icon variant="text" size="small" class="toggle-icon-btn">
            <v-icon :color="detailsExpanded ? '#ffffff' : '#C32E0E'" size="35">{{ detailsExpanded ? 'mdi-menu-up' :
              'mdi-menu-down' }}</v-icon>
          </v-btn>
        </div>
        <v-expand-transition>
          <v-card-text v-show="detailsExpanded" class="card-content">
            <v-row class="mt-2">
              <v-col cols="12" sm="6" md="5">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="User ID" class="text-sm font-medium text-gray-700">
                    User ID
                  </label>
                  <v-tooltip location="top" max-width="320px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                        style="cursor: pointer; margin-left: 4px;" />
                    </template>
                    <span>Indicates the chat platform used by the user (e.g., LINE, Web, Messenger).</span>
                  </v-tooltip>
                </div>
                <v-text-field v-model="userChannel" placeholder="454225" clearable variant="plain" density="compact"
                  color="grey" class="date-style" style="padding: 0 8px;" />
              </v-col>

              <v-col cols="12" sm="6" md="5">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="Session ID" class="text-sm font-medium text-gray-700">
                    Session ID
                  </label>
                  <v-tooltip location="top" max-width="320px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                        style="cursor: pointer; margin-left: 4px;" />
                    </template>
                    <span>A unique ID that helps identify this chat session.</span>
                  </v-tooltip>
                </div>
                <v-text-field v-model="sessionID" placeholder="*5780" clearable variant="plain" density="compact"
                  color="grey" class="date-style" style="padding: 0 8px;" />
              </v-col>

              <v-col cols="12" sm="12" md="2" class="d-flex justify-end align-end gap-2">
                <button type="button" @click="userChannel = null; sessionID = null;" class="clear-filters-btn">
                  <img src="@/assets/charm_cross.svg" alt="img" width="18" height="18" />
                  <span>{{ $t("ClearFilters") }}</span>
                </button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-expand-transition>
      </v-card> -->

      <!-- Action Buttons Row -->
      <v-row no-gutters class="my-4">
        <v-col cols="12" md="6">
          <div class="d-flex mr-4 align-center">
            <v-menu location="bottom">
              <template #activator="{ props }">
                <button class="download-btn-chat-log" v-bind="props">
                  <img src="@/assets/bxs_download.svg" alt="img" width="20" height="20" />
                  <span style="color: #ffffff; font-size: 14px;">{{ $t('Download') }}</span>
                </button>
              </template>
              <v-list class="download-menu">
                <div @click="GetExportLog()" class="download-list-item">
                  <img src="@/assets/tabler_message-down.svg" alt="img" width="20" height="20" />
                  <span style="font-size: 14px;">Export Log Message</span>
                </div>
                <div @click="GetExportLogMonitoring()" class="download-list-item">
                  <img src="@/assets/lucide_monitor-up.svg" alt="img" width="20" height="20" />
                  <span style="font-size: 14px;">Export Log Monitoring</span>
                </div>
                <div @click="dialogExportQS = true; GetDDValidationPositive();" class="download-list-item">
                  <img src="@/assets/uil_file-question.svg" alt="img" width="20" height="20" />
                  <span style="font-size: 14px;">Export to Question Set</span>
                </div>
              </v-list>
            </v-menu>
          </div>
        </v-col>

        <v-col cols="12" md="6" class="d-flex flex-row align-center justify-end">
          <div class="d-flex justify-start align-center ga-6">
            <span style="font-weight: 600; color: #171717; font-size: 16px;">Show All Text</span>
            <v-switch class="memory-switch" hide-details v-model="CheckboxShowAllText" />
          </div>
        </v-col>
      </v-row>

      <!-- Data Table with Modern Styling -->
      <v-card class="data-table-card mt-6">
        <v-card-text>
          <h2 style="font-weight: 600; color: #171717;">Log Data</h2>
        </v-card-text>
        <v-data-table-server v-model:options="options" :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable" :items="dataTable" :headers="headers" :loading="tableLoading" class="pa-4">

          <template #no-data>
            <div class="d-flex justify-center align-center fixed" style="width: 100%">
              <span style="color: #646464; font-weight: 400;">No Data Available</span>
            </div>
          </template>

          <template #item="{ item }">
            <tr class="table-row">
              <td style="text-align: left">
                {{ item.number }}
              </td>
              <td>
                <v-tooltip location="top start" text="View Flow">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" icon class="log-flow-icon-btn mb-1" variant="flat"
                      @click="openFlowDialog(item)" :disabled="item.chatWorkFlow == null" aria-label="Flow Button">
                      <v-icon size="24">mdi-source-branch</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.text)"></span>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.replymsg)"></span>
                  <v-tooltip v-if="item.replyHasMore" location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" @click="item.show = !item.show" size="small" variant="text"
                        :icon="item.show ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="primary"></v-btn>
                    </template>
                    <span>See All</span>
                  </v-tooltip>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.prompt)"></span>
                  <v-tooltip v-if="item.promptHasMore" location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" @click="item.show = !item.show" size="small" variant="text"
                        :icon="item.show ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="primary"></v-btn>
                    </template>
                    <span>See All</span>
                  </v-tooltip>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.vectorContext)"></span>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  {{ substringLong(item.id) }}
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <v-chip size="small" variant="outlined">{{ substringLong(item.sessionID) }}</v-chip>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.modelDisplay)"></span>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.modelName)"></span>
                </div>
              </td>
              <td style="text-align: left">
                <v-chip size="small" :color="item.userChannel ? 'primary' : 'grey'" variant="outlined">
                  {{ item.userChannel ?? '-' }}
                </v-chip>
              </td>
              <td style="text-align: left">{{ item.createDate ?? '-' }}</td>
              <td style="text-align: left">
                <v-chip size="small" color="success" variant="outlined">{{ item.responseTimeStr }}</v-chip>
              </td>
            </tr>
          </template>

          <template v-slot:bottom>
            <div class="table-bottom-group">
              <div class="table-container">
              </div>
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div>Total results {{ searchTotalTable }}</div>

                <v-data-table-footer :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]" :page="options.page" :length="Math.ceil(searchTotalTable / itemsPerPage)" />
              </div>
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <v-dialog v-model="dialogExportQS" max-width="700" persistent>
      <v-card class="question-dialog" elevation="0">
        <div class="question-header">
          <div class="header-text-content">
            <h2 class="question-title">Export log to Question Set</h2>
            <p style="font-size: 0.8rem;">Selects question set to export file</p>
          </div>
          <button type="button" @click="dialogExportQS = false" class="mt-2">
            <img src="@/assets/codex_cross.svg" alt="close" width="30" height="30" />
          </button>
        </div>
        <hr>
        <v-card-text>
          <div class="d-flex justify-start align-center gap-2">
            <img src="@/assets/mdi_information-variant-box.svg" alt="img" width="20" height="20">
            <p style="color: #171717; font-size: 18px;">Information</p>
          </div>
          <v-row no-gutters class="mt-2" align="end">
            <v-col cols="12" sm="9">
              <v-card class="pa-4 dialog-info-card" elevation="0">
                <v-row>
                  <v-col cols="12" sm="6">
                    <span>StartDate : <span class="modal-info">{{ startDate }}</span></span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>User Channel : <span class="modal-info">{{ userChannel ?? '-' }}</span></span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>EndDate : <span class="modal-info">{{ endDate }}</span></span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>SessionID : <span class="modal-info">{{ sessionID ?? '-' }}</span></span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>Type : <span class="modal-info">{{type_options.find((e) => e.value == type).name
                        }}</span></span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3" class="d-flex justify-center justify-sm-end">
              <button type="button" class="download-btn-chat-log" @click="ExportFileQuestionSet()">
                <img src="@/assets/bxs_download.svg" alt="img" width="20" height="20" />
                <span style="color: #ffffff; font-size: 14px;">{{ $t('Download') }}</span>
              </button>
            </v-col>
          </v-row>

          <div class="d-flex justify-start align-center gap-2 mt-10">
            <img src="@/assets/streamline-logos_google-chat-logo-block.svg" alt="img" width="20" height="20">
            <p style="color: #171717; font-size: 18px; font-weight: 500;">Chat Log</p>
          </div>

          <v-card class="advanced-filter-card mt-6 pa-4">
            <v-row class="align-center">
              <v-col cols="10">
                <div class="d-flex justify-space-between align-center">
                  <label style="color: #171717; font-size: 14px;">{{ questionSetLabel }}</label>
                </div>
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <button type="button" @click="showSelect = !showSelect" style="border: none;
                    border-radius: 50%; width: 32px; height: 32px; display: flex;
                    justify-content: center;align-items: center; cursor: pointer;">
                  <img src="@/assets/Add icon small.svg" alt="img" width="24" height="24" />
                </button>
              </v-col>
            </v-row>
            <hr>
            <div v-if="showSelect" class="question-set-ddl">
              <div v-for="item in dropdownItems" :key="item.name" @click="handleQuestionSetSelect(item)"
                style="padding: 8px 16px; cursor: pointer; border-radius: 6px; font-size: 15px; color: #171717; margin-bottom: 2px; white-space: pre-line;"
                :style="selectedOption === item.name ? 'background: #f5f5f5;' : ''">
                {{ item.name }}
              </div>
            </div>
            <v-text-field v-if="isAddingData" v-model="QuestionSetName" label="Enter new data" clearable outlined
              dense></v-text-field>
            <v-row class="align-center mt-6">
              <v-col cols="10">
                <div class="d-flex justify-space-between align-center">
                  <label style="color: #171717; font-size: 14px;">{{ questionTypeLabel }}</label>
                </div>
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <button type="button" @click="showSelectType = !showSelectType"
                  style="border: none; border-radius: 50%;
                    width: 32px; height: 32px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                  <img src="@/assets/Add icon small.svg" alt="img" width="24" height="24" />
                </button>
              </v-col>
            </v-row>
            <div style="margin-bottom: 12px;">
              <hr>
            </div>
            <div v-if="showSelectType"
              style="border-radius: 14px; margin-top: 10px; background: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.07); max-height: 220px; overflow-y: auto; overflow-x: hidden;">
              <div v-for="item in dropdownItemsQSType" :key="item.name" @click="handleQuestionTypeSelect(item)"
                style="padding: 8px 16px; cursor: pointer; border-radius: 6px; font-size: 15px; color: #171717; margin-bottom: 2px; white-space: pre-line;"
                :style="selectedOptionQSName === item.name ? 'background: #f5f5f5;' : ''">
                {{ item.name }}
              </div>
            </div>
          </v-card>

        </v-card-text>
        <div class="mt-2">
          <hr />
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="category-dialog-footer">
            <button type="button" class="footer-btn cancel" @click="dialogExportQS = false">Cancel</button>
            <button type="button" class="footer-btn save" @click="ExportQuestionSet">
              <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
              <span style="color: #ffffff; font-size: 14px;">{{ $t("add") }}</span>
            </button>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--View Flow Dialog - Horizontal Layout -->
    <v-dialog v-model="dialogFlow" max-width="1400" scrollable transition="dialog-bottom-transition" :scrim="true"
      @close="expandedStep = null">
      <v-card class="flow-dialog-card">
        <v-card-title class="flow-dialog-header pa-0">
          <div class="flow-header-content">
            <div class="d-flex flex-column align-center">
              <div class="flow-title">Flow Visualization</div>
              <div class="flow-subtitle">Step-by-step execution tracking</div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="flow-dialog-content pa-0">
          <div v-if="flowSteps && flowSteps.length > 0" class="horizontal-flow-container">
            <!-- Flow Steps in Horizontal Layout -->
            <div class="horizontal-flow-steps" :class="{ 'has-overflow': flowHasOverflow }"
              style="overflow-x: auto; overflow-y: hidden; padding-bottom: 20px">
              <div v-for="(group, groupIndex) in groupedFlowSteps" :key="group.stepId" class="horizontal-step-wrapper">
                <!-- Container for parallel steps (vertical layout if multiple) -->
                <div class="step-group-container" :class="{ 'parallel-steps': group.isParallel }">
                  <div v-for="(step, stepIndex) in group.steps" :key="`${step.stepId}-${step.node}-${stepIndex}`"
                    class="step-item" :class="{ 'parallel-item': group.isParallel }">
                    <!-- Checkpoint Style for Input/Output -->
                    <div v-if="step.node === 'messageInput' || step.node === 'response'" class="checkpoint-node"
                      :class="[getStepStatusClass(step.status), { active: isStepSelected(step) }]"
                      :data-node-type="step.node" @click="toggleStepDetails(step)">
                      <!-- Selection Indicator -->
                      <div v-if="isStepSelected(step)" class="selection-indicator">
                        <v-icon size="12" color="white">mdi-check-circle</v-icon>
                      </div>

                      <!-- Checkpoint Icon -->
                      <div class="checkpoint-icon" :style="{ backgroundColor: getNodeTypeColor(step.node) }">
                        <v-icon color="white" size="16">{{ getNodeIcon(step.node) }}</v-icon>
                      </div>

                      <!-- Checkpoint Label -->
                      <div class="checkpoint-label">
                        {{ formatNodeName(step.node) }}
                      </div>

                      <!-- Checkpoint Time Info -->
                      <div class="checkpoint-time-info">
                        <div class="checkpoint-time">
                          {{ formatTime(step.node === 'messageInput' ? step.startTime : step.endTime) }}
                        </div>
                        <div v-if="step.responseTimeMs" class="checkpoint-duration" :style="{
                          border: `1px solid ${getResponseTimeColor(step.responseTimeMs)}`,
                          color: getResponseTimeColor(step.responseTimeMs),
                          fontWeight: '700',
                        }">
                          {{ step.responseTimeMs }}ms
                        </div>
                      </div>
                    </div>

                    <!-- Card Style for Intent/Model/InterestOptimizer and new nodes -->
                    <div v-else-if="
                      step.node === 'intent' ||
                      step.node === 'model' ||
                      step.node === 'interestOptimizer' ||
                      step.node === 'apiknowledge' ||
                      step.node === 'databaseIntegration' ||
                      step.node === 'apiTrigger' ||
                      step.node === 'contactAgent' ||
                      step.node === 'loanInterest' ||
                      step.node === 'documents' ||
                      step.node === 'embedding' ||
                      step.node === 'smartIntent' ||
                      step.node === 'advancedRouter' ||
                      step.node === 'queryRewriter' ||
                      step.node === 'merge'
                    " class="flow-card-node"
                      :class="[getStepStatusClass(step.status), { active: isStepSelected(step) }]"
                      :data-node-type="step.node" @click="toggleStepDetails(step)">
                      <!-- Action Type Badge -->
                      <div v-if="group.isParallel" class="action-type-badge"
                        :class="{ 'main-action': step.next && step.next.length > 0, 'parallel-action': !step.next || step.next.length === 0 }">
                        <v-icon v-if="step.next && step.next.length > 0" size="8">mdi-arrow-right-bold</v-icon>
                        <v-icon v-else size="8">mdi-arrow-split-vertical</v-icon>
                        <span>{{ step.next && step.next.length > 0 ? 'Main' : 'Parallel' }}</span>
                      </div>

                      <!-- Selection Indicator -->
                      <div v-if="isStepSelected(step)" class="card-selection-indicator">
                        <v-icon size="16" color="white">mdi-check-circle</v-icon>
                        <span class="selection-text">Selected</span>
                      </div>

                      <!-- Card Header -->
                      <div class="card-header-section">
                        <div class="card-header">
                          <div class="card-icon" :style="{ background: getNodeIconGradient(step.node) }">
                            <v-icon color="white" size="20">{{ getNodeIcon(step.node) }}</v-icon>
                          </div>
                          <div class="card-info">
                            <div class="card-title">{{ formatNodeName(step.node) }}</div>
                            <div v-if="step.node === 'intent' || step.node === 'smartIntent' || step.node === 'advancedRouter'" class="card-subtitle">"{{
                              step.output.message }}"</div>
                          </div>
                        </div>
                      </div>

                      <!-- Card Time Info -->
                      <div class="card-time-info">
                        <div class="card-time">
                          <v-icon size="10" class="mr-1">mdi-clock-outline</v-icon>
                          {{ formatTime(step.startTime) }}
                        </div>
                        <div v-if="step.responseTimeMs" class="card-duration" :style="{
                          border: `1px solid ${getResponseTimeColor(step.responseTimeMs)}`,
                          color: getResponseTimeColor(step.responseTimeMs)
                        }">
                          <v-icon size="10" class="mr-1"
                            :color="getResponseTimeColor(step.responseTimeMs)">mdi-timer-outline</v-icon>
                          {{ step.responseTimeMs }}ms
                        </div>
                      </div>
                    </div>

                    <!-- Regular Node Style for Other Processing Steps -->
                    <div v-else class="flow-node"
                      :class="[getStepStatusClass(step.status), { active: isStepSelected(step) }]"
                      :data-node-type="step.node" @click="toggleStepDetails(step)">
                      <!-- Action Type Badge -->
                      <div v-if="group.isParallel" class="action-type-badge-node"
                        :class="{ 'main-action': step.next && step.next.length > 0, 'parallel-action': !step.next || step.next.length === 0 }">
                        <v-icon v-if="step.next && step.next.length > 0" size="7">mdi-arrow-right-bold</v-icon>
                        <v-icon v-else size="7">mdi-arrow-split-vertical</v-icon>
                        <span>{{ step.next && step.next.length > 0 ? 'Main' : 'Parallel' }}</span>
                      </div>

                      <!-- Selection Indicator -->
                      <div v-if="isStepSelected(step)" class="node-selection-indicator">
                        <v-icon size="14" color="white">mdi-check-circle</v-icon>
                      </div>

                      <!-- Node Header -->
                      <div class="node-header">
                        <div class="node-icon" :style="{ backgroundColor: getNodeTypeColor(step.node) }">
                          <v-icon color="white" size="20">{{ getNodeIcon(step.node) }}</v-icon>
                        </div>
                        <div class="node-info">
                          <div class="node-title">{{ formatNodeName(step.node) }}</div>
                        </div>
                      </div>

                      <!-- Node Time Info -->
                      <div class="node-time-info">
                        <div class="node-time">
                          <v-icon size="12" class="mr-1">mdi-clock-outline</v-icon>
                          {{ formatTime(step.startTime) }}
                        </div>
                        <div v-if="step.responseTimeMs" class="node-duration" :style="{
                          backgroundColor: getResponseTimeColor(step.responseTimeMs),
                          color: 'white',
                        }">
                          <v-icon size="12" class="mr-1" color="white">mdi-timer-outline</v-icon>
                          {{ step.responseTimeMs }}ms
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Connection Arrow -->
                <div v-if="groupIndex < groupedFlowSteps.length - 1" class="horizontal-arrow">
                  <v-icon size="20" color="primary" class="arrow-icon">mdi-arrow-right</v-icon>
                </div>
              </div>
            </div>

            <!-- Instruction Panel (when no node selected) -->
            <transition name="slide-fade">
              <div v-if="!expandedStep" class="instruction-panel">
                <v-card variant="outlined" class="mt-4 instruction-card">
                  <v-card-text class="pa-6 text-center">
                    <div class="instruction-icon-wrapper mb-4">
                      <v-icon size="64" color="#3859D0"
                        class="instruction-icon">mdi-cursor-default-click-outline</v-icon>
                    </div>
                    <h3 class="instruction-title mb-3">Select a Node to View Details</h3>
                    <p class="instruction-subtitle mb-4">Click on any node above to see its input/output data and timing
                      information</p>
                  </v-card-text>
                </v-card>
              </div>
            </transition>

            <!-- Step Details Panel (when expanded) -->
            <transition name="slide-fade">
              <div v-if="expandedStep" class="step-details-panel">
                <v-card variant="outlined" class="mt-4 details-card">
                  <v-card-title class="pa-3">
                    <v-icon class="mr-2" :color="getNodeTypeColor(expandedStep.node)">{{ getNodeIcon(expandedStep.node)
                      }}</v-icon>
                    {{ formatNodeName(expandedStep.node) }} - Details
                  </v-card-title>
                  <v-card-text class="pa-3">
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="data-section-label">Input Data</div>
                        <div class="data-display-card">
                          <div class="data-content">{{ JSON.stringify(expandedStep.input.message, null, 2) }}</div>
                          <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                            @click="copyToClipboard(JSON.stringify(expandedStep.input.message, null, 2))"
                            class="data-copy-btn">
                            <v-icon size="16">mdi-content-copy</v-icon>
                            <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="data-section-label">Output Data</div>
                        <div class="data-display-card">
                          <div class="data-content">{{ JSON.stringify(expandedStep.output.message, null, 2) }}</div>
                          <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                            @click="copyToClipboard(JSON.stringify(expandedStep.output.message, null, 2))"
                            class="data-copy-btn">
                            <v-icon size="16">mdi-content-copy</v-icon>
                            <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>

                    <!-- Log References Section -->
                    <div v-if="expandedStep.logRefs && expandedStep.logRefs.length > 0" class="mt-4">
                      <h4 class="mb-2">Log References ({{ expandedStep.logRefs.length }})</h4>

                      <!-- Loading State -->
                      <div v-if="expandedStep.loadingRefs" class="text-center py-4">
                        <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                        <p class="mt-2 text-caption">Loading reference data...</p>
                      </div>

                      <!-- Data Display as Table - Intent/SmartIntent/Model nodes -->
                      <div
                        v-else-if="expandedStep.logRefsData && expandedStep.logRefsData.length > 0 && expandedStep.node !== 'apiTrigger' && expandedStep.node !== 'apiknowledge' && expandedStep.node !== 'documents'"
                        class="log-refs-table-container">
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th v-if="expandedStep.node && expandedStep.node !== 'embedding'" class="text-center" style="width: 60px">Monitor</th>
                              <th
                                v-if="expandedStep && (expandedStep.node === 'intent' || expandedStep.node === 'smartIntent' || expandedStep.node === 'advancedRouter')"
                                class="text-left">Intent</th>
                              <th class="text-left">Message</th>
                              <th class="text-left">Reply</th>
                              <th class="text-center">Tokens</th>
                              <th class="text-center">Response Time</th>
                              <th class="text-left">Endpoint</th>
                              <th
                                v-if="expandedStep && (expandedStep.node === 'intent' || expandedStep.node === 'smartIntent' || expandedStep.node === 'advancedRouter')"
                                class="text-center">Used</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.logRefsData" :key="idx" class="log-ref-row">
                              <td v-if="expandedStep.node && expandedStep.node !== 'embedding'" class="text-center">
                                <v-btn size="x-small" variant="text" color="#3859D0" icon="mdi-monitor-eye"
                                  @click="openMonitorDetails(refData.id, expandedStep.node, expandedStep.node === 'advancedRouter' ? refData.logRouterID : null)" class="monitor-btn">
                                  <v-icon size="18">mdi-monitor-eye</v-icon>
                                  <v-tooltip activator="parent" location="top">View Monitor</v-tooltip>
                                </v-btn>
                              </td>
                              <td
                                v-if="expandedStep && (expandedStep.node === 'intent' || expandedStep.node === 'smartIntent' || expandedStep.node === 'advancedRouter')"
                                class="text-left">
                                <v-chip @click="copyToClipboard(refData.intentName || '-')" size="small" color="#AC00DE"
                                  variant="outlined" v-if="refData.intentName">
                                  {{ refData.intentName }}
                                  <v-tooltip text="Copy" location="top">
                                    <template #activator="{ props }">
                                      <v-icon v-bind="props" size="12" class="ml-1"
                                        @click.stop="copyToClipboard(refData.intentName || '-')" color="#646464">
                                        mdi-content-copy
                                      </v-icon>
                                    </template>
                                  </v-tooltip>
                                </v-chip>
                                <span v-else class="text-grey">-</span>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 200px; cursor: pointer"
                                  :title="(refData.message || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.message || '-')">
                                  {{ refData.message || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 200px; cursor: pointer"
                                  :title="(refData.reply || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.reply || '-')">
                                  {{ refData.reply || '-' }}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="token-info">
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-chip size="x-small" color="primary" variant="outlined" v-bind="props">
                                        {{ refData.totalTokens || 0 }}
                                      </v-chip>
                                    </template>
                                    <div>
                                      Prompt: {{ refData.promptTokens || 0 }}<br />
                                      Completion: {{ refData.completionTokens || 0 }}<br />
                                      Total: {{ refData.totalTokens || 0 }}<br />
                                      Cached: {{ refData.cachedTokens || 0 }}
                                    </div>
                                  </v-tooltip>
                                </div>
                              </td>
                              <td class="text-center">
                                <v-chip size="x-small" variant="outlined" :style="{
                                  borderColor: getResponseTimeColor(refData.responseTime),
                                  color: getResponseTimeColor(refData.responseTime)
                                }">
                                  {{ refData.responseTime ? refData.responseTime.toFixed(2) + 'ms' : '-' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 150px; cursor: pointer"
                                  :title="(refData.urlEndpoint || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.urlEndpoint || '-')">
                                  {{ refData.urlEndpoint || '-' }}
                                </div>
                              </td>
                              <td
                                v-if="expandedStep && (expandedStep.node === 'intent' || expandedStep.node === 'smartIntent' || expandedStep.node === 'advancedRouter')"
                                class="text-center">
                                <v-chip class="used-status-pill" :variant="refData.isUse ? 'flat' : 'outlined'"
                                  :color="refData.isUse ? 'success' : 'grey'" />
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- API Trigger / API Knowledge Table -->
                      <div
                        v-else-if="expandedStep.logRefsData && expandedStep.logRefsData.length > 0 && (expandedStep.node === 'apiTrigger' || expandedStep.node === 'apiknowledge')"
                        class="log-refs-table-container">
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th class="text-left">Method</th>
                              <th class="text-left">API Endpoint</th>
                              <th class="text-left">Request Body</th>
                              <th class="text-left">JSON Response</th>
                              <th class="text-center">Status Code</th>
                              <th class="text-left">Status Name</th>
                              <th class="text-center">Response Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.logRefsData" :key="idx" class="log-ref-row">
                              <td class="text-left">
                                <v-chip size="x-small"
                                  :color="refData.method === 'GET' ? 'green' : refData.method === 'POST' ? 'blue' : refData.method === 'PUT' ? 'orange' : refData.method === 'DELETE' ? 'red' : 'grey'"
                                  variant="flat" class="text-white">
                                  {{ refData.method || '-' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 200px; cursor: pointer"
                                  :title="(refData.apiEndPoint || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.apiEndPoint || '-')">
                                  {{ refData.apiEndPoint || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 200px; cursor: pointer"
                                  :title="(refData.requestBody || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.requestBody || '-')">
                                  {{ refData.requestBody || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 200px; cursor: pointer"
                                  :title="(refData.jsonResponse || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.jsonResponse || '-')">
                                  {{ refData.jsonResponse || '-' }}
                                </div>
                              </td>
                              <td class="text-center">
                                <v-chip size="x-small"
                                  :color="refData.statusCode >= 200 && refData.statusCode < 300 ? 'success' : refData.statusCode >= 400 ? 'error' : 'warning'"
                                  variant="flat" class="text-white">
                                  {{ refData.statusCode || '-' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 150px">
                                  {{ refData.statusName || '-' }}
                                </div>
                              </td>
                              <td class="text-center">
                                <v-chip size="x-small" :color="getResponseTimeColor(refData.responseTime)"
                                  variant="outlined" class="text-white">
                                  {{ refData.responseTime ? refData.responseTime.toFixed(2) + 'ms' : '-' }}
                                </v-chip>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- Documents Table -->
                      <div
                        v-else-if="expandedStep.logRefsData && expandedStep.logRefsData.length > 0 && expandedStep.node === 'documents'"
                        class="log-refs-table-container">
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th class="text-left">ID</th>
                              <th class="text-left">Document Name</th>
                              <th class="text-left">Text ORG</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.logRefsData" :key="idx" class="log-ref-row">
                              <td class="text-left">
                                <v-chip size="x-small" color="green" variant="flat" class="text-white">
                                  {{ refData.id || '-' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 200px; cursor: pointer"
                                  :title="(refData.documentName || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.documentName || '-')">
                                  {{ refData.documentName || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 200px; cursor: pointer"
                                  :title="(refData.textORG || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.textORG || '-')">
                                  {{ refData.textORG || '-' }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- IDs Display (before loading or no data) -->
                      <div v-else class="log-refs-ids">
                        <v-chip v-for="(refId, idx) in expandedStep.logRefs" :key="idx" class="ma-1" size="small"
                          variant="outlined" color="primary">
                          ID: {{ refId }}
                        </v-chip>
                      </div>
                    </div>

                    <div class="mt-3">
                      <h6 class="mt-4 font-weight-bold" style="color: #1C1D1D;font-size: 16px;">Timing</h6>
                      <div class="timing-compact">
                        <div class="timing-item">
                          <span class="timing-label">Start:</span>
                          <span class="timing-value">{{ formatDateTime(expandedStep.startTime) }}</span>
                        </div>
                        <div class="timing-item">
                          <span class="timing-label">End:</span>
                          <span class="timing-value">{{ formatDateTime(expandedStep.endTime) }}</span>
                        </div>
                        <div class="timing-item" v-if="expandedStep.responseTimeMs">
                          <span class="timing-label">Duration:</span>
                          <span class="duration-badge-compact" :style="{
                            border: `1px solid ${getResponseTimeColor(expandedStep.responseTimeMs)}`,
                            color: getResponseTimeColor(expandedStep.responseTimeMs)
                          }">
                            {{ expandedStep.responseTimeMs }}ms
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </transition>
          </div>

          <div v-else class="text-center py-12">
            <v-icon size="64" color="grey-lighten-1">mdi-flow</v-icon>
            <h3 class="mt-4 text-grey">No Flow Data Available</h3>
          </div>
        </v-card-text>

        <v-card-actions class="flow-dialog-footer">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" class="flow-dialog-close-btn" color="#C30000"
            @click="dialogFlow = false; expandedStep = null">
            <v-icon class="mr-2" size="25" color="#C30000">mdi-close</v-icon>
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Monitor Dialog -->
    <v-dialog v-model="dialogMonitor" max-width="900" scrollable>
      <v-card style="border-radius: 22px">
        <v-card-title class="d-flex align-center" style="border-bottom: 1px solid #DCDCDC;">
          <div class="d-flex flex-column align-center">
            <div class="flow-title">Monitor Details</div>
            <div class="flow-subtitle">System & Prompts Details</div>
          </div>
        </v-card-title>

        <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
          <!-- Loading State -->
          <div v-if="loadingMonitor" class="text-center py-8">
            <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
            <p class="mt-4 text-subtitle-1">Loading monitor data...</p>
          </div>

          <!-- Monitor Data Display -->
          <div v-else-if="monitorData" class="monitor-content-new">
            <!-- Quick Info Cards -->
            <v-row class="mb-4">
              <v-col cols="12" md="6">
                <v-card variant="outlined" class="info-card">
                  <v-card-text class="pa-3">
                    <div class="d-flex align-center mb-2">
                      <v-icon color="#C32E0E" class="mr-2">mdi-account-voice</v-icon>
                      <span style="color: #171717;font-size: 18px;font-weight: 600;">User Query</span>
                    </div>
                    <div class="text-body-2 font-weight-medium text-truncate" :title="monitorData.TextVector">
                      {{ monitorData.TextVector || '-' }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card variant="outlined" class="info-card">
                  <v-card-text class="pa-3">
                    <div class="d-flex align-center mb-2">
                      <img :src="monitorIcons.model" class="mr-2" contain width="24" height="24" />
                      <span style="color: #171717;font-size: 18px;font-weight: 600;">Model</span>
                    </div>
                    <div class="text-body-2 font-weight-medium">
                      {{ monitorData.GPT_Model?.ModelName || '-' }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- Expandable Sections -->
            <div class="monitor-panels">
              <!-- System & Prompts -->
              <v-card class="monitor-expandable-card" elevation="0">
                <div
                  :class="['monitor-expandable-header', { 'monitor-expandable-header-expanded': monitorPanelExpanded.system }]"
                  @click="monitorPanelExpanded.system = !monitorPanelExpanded.system" role="button"
                  :aria-expanded="monitorPanelExpanded.system" tabindex="0">
                  <div class="header-left">
                    <img :src="monitorIcons.system" :class="{ 'icon-white-filter': monitorPanelExpanded.system }"
                      width="24" height="24" />
                    <div>
                      <span class="font-weight-bold">System & Prompts</span>
                      <div :class="['text-caption', monitorPanelExpanded.system ? 'text-white' : 'text-grey']">System
                        message and workflow configuration</div>
                    </div>
                  </div>
                  <v-btn icon variant="text" size="small" class="toggle-icon-btn">
                    <v-icon :color="monitorPanelExpanded.system ? '#ffffff' : '#C32E0E'" size="35">{{
                      monitorPanelExpanded.system ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                  </v-btn>
                </div>
                <v-expand-transition>
                  <v-card-text v-show="monitorPanelExpanded.system" class="monitor-card-content">
                    <v-card elevation="0" class="rounded-xl monitor-dialog-expand-card">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-message-text</v-icon>
                        System Message
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy" class="ml-1"
                          @click="copyToClipboard(monitorData.Prompt)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.Prompt" variant="outlined" readonly
                          rows="6" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>

                    <v-card elevation="0" class="rounded-xl monitor-dialog-expand-card mt-3">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mx-1" color="#C32E0E">mdi-source-branch</v-icon>
                        Work Flow
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.FlowActionIntent)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.FlowActionIntent" variant="outlined"
                          readonly rows="2" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                </v-expand-transition>
              </v-card>

              <!-- Knowledge & Vectors -->
              <v-card class="monitor-expandable-card" elevation="0">
                <div
                  :class="['monitor-expandable-header', { 'monitor-expandable-header-expanded': monitorPanelExpanded.knowledge }]"
                  @click="monitorPanelExpanded.knowledge = !monitorPanelExpanded.knowledge" role="button"
                  :aria-expanded="monitorPanelExpanded.knowledge" tabindex="0">
                  <div class="header-left">
                    <img :src="monitorIcons.knowledge"
                      :class="{ 'icon-white-filter': monitorPanelExpanded.knowledge }" width="24" height="24" />
                    <div>
                      <span class="font-weight-bold">Knowledge & Vectors</span>
                      <div :class="['text-caption', monitorPanelExpanded.knowledge ? 'text-white' : 'text-grey']">Vector
                        database and similarity search results</div>
                    </div>
                  </div>
                  <v-btn icon variant="text" size="small" class="toggle-icon-btn">
                    <v-icon :color="monitorPanelExpanded.knowledge ? '#ffffff' : '#C32E0E'" size="35">{{
                      monitorPanelExpanded.knowledge ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                  </v-btn>
                </div>
                <v-expand-transition>
                  <v-card-text v-show="monitorPanelExpanded.knowledge" class="monitor-card-content">
                    <v-card variant="outlined" class="mb-3 rounded-xl">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-database-search</v-icon>
                        Knowledge
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.Vector)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.Vector" variant="outlined" readonly
                          rows="3" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="mb-3 rounded-xl">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-vector-triangle</v-icon>
                        Vector Cosine Similarity
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.VectorCoise)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.VectorCoise" variant="outlined"
                          readonly rows="3" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>

                    <v-row>
                      <v-col cols="12" md="6">
                        <v-card variant="outlined" class="rounded-xl pa-1">
                          <v-card-subtitle class="section-label">
                            <v-icon size="small" class="mr-1" color="#C32E0E">mdi-text-search</v-icon>
                            Original Search
                          </v-card-subtitle>
                          <v-card-text>
                            <div class="text-body-2">{{ monitorData.Text || '-' }}</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card variant="outlined" class="rounded-xl pa-1">
                          <v-card-subtitle class="section-label">
                            <v-icon size="small" class="mr-1" color="#C32E0E">mdi-text-search-variant</v-icon>
                            Modified Search
                          </v-card-subtitle>
                          <v-card-text>
                            <div class="text-body-2">{{ monitorData.Translate || '-' }}</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-expand-transition>
              </v-card>

              <!-- Database -->
              <v-card class="monitor-expandable-card" elevation="0">
                <div
                  :class="['monitor-expandable-header', { 'monitor-expandable-header-expanded': monitorPanelExpanded.database }]"
                  @click="monitorPanelExpanded.database = !monitorPanelExpanded.database" role="button"
                  :aria-expanded="monitorPanelExpanded.database" tabindex="0">
                  <div class="header-left">
                    <v-icon :color="monitorPanelExpanded.database ? '#ffffff' : '#C32E0E'"
                      size="24">mdi-database</v-icon>
                    <div>
                      <span class="font-weight-bold">Database Integration</span>
                      <div :class="['text-caption', monitorPanelExpanded.database ? 'text-white' : 'text-grey']">SQL
                        queries
                        and results</div>
                    </div>
                  </div>
                  <v-btn icon variant="text" size="small" class="toggle-icon-btn">
                    <v-icon :color="monitorPanelExpanded.database ? '#ffffff' : '#C32E0E'" size="35">{{
                      monitorPanelExpanded.database ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                  </v-btn>
                </div>
                <v-expand-transition>
                  <v-card-text v-show="monitorPanelExpanded.database" class="monitor-card-content">
                    <v-card variant="outlined" class="mb-3 rounded-xl">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-code-tags</v-icon>
                        SQL Query
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.ReplySQL)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.ReplySQL" variant="outlined" readonly
                          rows="3" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="rounded-xl">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-table</v-icon>
                        Query Result
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.ReplyDataSelect)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.ReplyDataSelect" variant="outlined"
                          readonly rows="3" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                </v-expand-transition>
              </v-card>

              <!-- Memory -->
              <v-card class="monitor-expandable-card" elevation="0">
                <div
                  :class="['monitor-expandable-header', { 'monitor-expandable-header-expanded': monitorPanelExpanded.memory }]"
                  @click="monitorPanelExpanded.memory = !monitorPanelExpanded.memory" role="button"
                  :aria-expanded="monitorPanelExpanded.memory" tabindex="0">
                  <div class="header-left">
                    <img :src="monitorIcons.memory" :class="{ 'icon-white-filter': monitorPanelExpanded.memory }"
                      width="24" height="24" />
                    <div>
                      <span class="font-weight-bold">Memory & Context</span>
                      <div :class="['text-caption', monitorPanelExpanded.memory ? 'text-white' : 'text-grey']">
                        Conversation
                        history and private memory</div>
                    </div>
                  </div>
                  <v-btn icon variant="text" size="small" class="toggle-icon-btn">
                    <v-icon :color="monitorPanelExpanded.memory ? '#ffffff' : '#C32E0E'" size="35">{{
                      monitorPanelExpanded.memory ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                  </v-btn>
                </div>
                <v-expand-transition>
                  <v-card-text v-show="monitorPanelExpanded.memory" class="monitor-card-content">
                    <v-card variant="outlined" class="mb-3 rounded-xl">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-history</v-icon>
                        Conversation Memory
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.Memory)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.Memory" variant="outlined" readonly
                          rows="4" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="mb-3 rounded-xl">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-code-json</v-icon>
                        JSON Memory Raw
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.JsonMemoryRaw)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.JsonMemoryRaw" variant="outlined"
                          readonly rows="4" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="rounded-xl">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-cloud-lock-outline</v-icon>
                        Private Memory
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.Private_Memory)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" v-model="monitorData.Private_Memory" variant="outlined"
                          readonly rows="3" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                </v-expand-transition>
              </v-card>

              <!-- Model Configuration -->
              <v-card class="monitor-expandable-card" elevation="0">
                <div
                  :class="['monitor-expandable-header', { 'monitor-expandable-header-expanded': monitorPanelExpanded.modelConfig }]"
                  @click="monitorPanelExpanded.modelConfig = !monitorPanelExpanded.modelConfig" role="button"
                  :aria-expanded="monitorPanelExpanded.modelConfig" tabindex="0">
                  <div class="header-left">
                    <img :src="monitorIcons.modelConfig"
                      :class="{ 'icon-white-filter': monitorPanelExpanded.modelConfig }" width="24" height="24" />
                    <div>
                      <span class="font-weight-bold">Model Configuration</span>
                      <div :class="['text-caption', monitorPanelExpanded.modelConfig ? 'text-white' : 'text-grey']">LLM
                        parameters and settings</div>
                    </div>
                  </div>
                  <v-btn icon variant="text" size="small" class="toggle-icon-btn">
                    <v-icon :color="monitorPanelExpanded.modelConfig ? '#ffffff' : '#C32E0E'" size="35">{{
                      monitorPanelExpanded.modelConfig ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                  </v-btn>
                </div>
                <v-expand-transition>
                  <v-card-text v-show="monitorPanelExpanded.modelConfig" class="monitor-card-content">
                    <v-card variant="outlined" class="mb-3 rounded-xl py-2">
                      <v-card-subtitle class="section-label bg-primary" style="margin-top: 0">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-information</v-icon>
                        <span style="color: #171717">Model Information</span>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="6" md="3">
                            <div class="param-label">Model ID</div>
                            <div class="param-value">{{ monitorData.GPT_Model?.ModelID || '-' }}</div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">Provider</div>
                            <div class="param-value">{{ monitorData.GPT_Model?.Provider || '-' }}</div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">Model</div>
                            <div class="param-value">{{ monitorData.GPT_Model?.Model || '-' }}</div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">Gender</div>
                            <div class="param-value">
                              <v-chip size="small"
                                :color="monitorData.GPT_Model?.gender === 'm' ? '#3859D0' : monitorData.GPT_Model?.gender === 'f' ? '#C32E0E' : 'grey'"
                                variant="outlined">
                                {{ monitorData.GPT_Model?.gender === 'm' ? 'Male' : monitorData.GPT_Model?.gender ===
                                  'f'
                                  ?
                                  'Female' : monitorData.GPT_Model?.gender || '-' }}
                              </v-chip>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="mb-3 rounded-xl py-2">
                      <v-card-subtitle class="section-label bg-success" style="margin-top: 0">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-tune</v-icon>
                        <span style="color: #171717">Generation Parameters</span>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="6" md="3">
                            <div class="param-label">Temperature</div>
                            <div class="param-value">
                              <v-chip size="small" color="#FFA726" variant="outlined">
                                {{ monitorData.GPT_Model?.temperature }}
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">Top P</div>
                            <div class="param-value">
                              <v-chip size="small" color="#3859D0" variant="outlined">
                                {{ monitorData.GPT_Model?.top_p }}
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">Frequency Penalty</div>
                            <div class="param-value">
                              <v-chip size="small" color="#872612" variant="outlined">
                                {{ monitorData.GPT_Model?.frequency_penalty }}
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">Presence Penalty</div>
                            <div class="param-value">
                              <v-chip size="small" color="#872612" variant="outlined">
                                {{ monitorData.GPT_Model?.presence_penalty }}
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">Max Tokens</div>
                            <div class="param-value">
                              <v-chip size="small" color="#2ABF56" variant="outlined">
                                {{ monitorData.GPT_Model?.max_tokens }}
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">History Count</div>
                            <div class="param-value">{{ monitorData.GPT_Model?.HistoryCount || '-' }}</div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">History Minute</div>
                            <div class="param-value">{{ monitorData.GPT_Model?.HistoryMinute || '-' }}</div>
                          </v-col>
                          <v-col cols="6" md="3">
                            <div class="param-label">Stream</div>
                            <div class="param-value">
                              <v-chip size="small" :color="monitorData.GPT_Model?.IsStream ? '#2ABF56' : '#858585'"
                                variant="flat">
                                {{ monitorData.GPT_Model?.IsStream ? 'Yes' : 'No' }}
                              </v-chip>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="mb-3 rounded-xl py-1">
                      <v-card-subtitle class="section-label">
                        <v-icon size="small" class="mr-1" color="#C32E0E">mdi-database-cog</v-icon>
                        Knowledge Documents
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.GPT_Model?.vectordbName)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" :model-value="monitorData.GPT_Model?.vectordbName"
                          variant="outlined" readonly rows="2" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>

                    <v-card variant="outlined" class="rounded-xl py-1 mb-3">
                      <v-card-subtitle class="section-label d-flex align-center">
                        <img :src="monitorIcons.endPointUrl" alt="Endpoint URL" class="mr-1" width="24"
                          height="24" />
                        Endpoint URL
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          @click="copyToClipboard(monitorData.GPT_Model?.EndpointURL)"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" :model-value="monitorData.GPT_Model?.EndpointURL"
                          variant="outlined" readonly rows="2" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>

                    <!-- Content Request Body - new card ?-->
                    <v-card variant="outlined" class="rounded-xl py-1">
                      <v-card-subtitle class="section-label d-flex align-center">
                        <img :src="monitorIcons.contentRequestBody" alt="Content Request Body" class="mr-1"
                          width="24" height="24" />
                        Content Request Body
                      </v-card-subtitle>
                      <v-card-text style="position: relative">
                        <v-btn size="x-small" variant="text" color="grey" icon="mdi-content-copy"
                          style="position: absolute; top: 14px; right: 12px; z-index: 1">
                          <v-icon size="16">mdi-content-copy</v-icon>
                          <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                        </v-btn>
                        <v-textarea class="Log_text_textarea" :model-value="monitorData.ContentRequest"
                          variant="outlined" readonly rows="10" hide-details></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                </v-expand-transition>
              </v-card>

              <!-- AI Attempts -->
              <v-card class="monitor-expandable-card" elevation="0">
                <div
                  :class="['monitor-expandable-header', { 'monitor-expandable-header-expanded': monitorPanelExpanded.aiAttempts }]"
                  @click="monitorPanelExpanded.aiAttempts = !monitorPanelExpanded.aiAttempts" role="button"
                  :aria-expanded="monitorPanelExpanded.aiAttempts" tabindex="0">
                  <div class="header-left">
                    <v-icon :color="monitorPanelExpanded.aiAttempts ? '#ffffff' : '#C32E0E'" size="24">mdi-robot</v-icon>
                    <div>
                      <span class="font-weight-bold">AI Attempts
                        <v-chip 
                          v-if="monitorData.AiAttempts && monitorData.AiAttempts.length > 0"
                          size="x-small" 
                          :color="monitorData.AiAttempts.some(a => a.Success === true) ? 'success' : 'error'" 
                          variant="flat"
                          class="ml-2"
                        >
                          {{ monitorData.AiAttempts.length }}
                        </v-chip>
                      </span>
                      <div :class="['text-caption', monitorPanelExpanded.aiAttempts ? 'text-white' : 'text-grey']">Endpoint usage and retries</div>
                    </div>
                  </div>
                  <v-btn icon variant="text" size="small" class="toggle-icon-btn">
                    <v-icon :color="monitorPanelExpanded.aiAttempts ? '#ffffff' : '#C32E0E'" size="35">{{
                      monitorPanelExpanded.aiAttempts ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                  </v-btn>
                </div>
                <v-expand-transition>
                  <v-card-text v-show="monitorPanelExpanded.aiAttempts" class="monitor-card-content">
                    <div v-if="monitorData.AiAttempts && monitorData.AiAttempts.length > 0">
                      <v-card variant="outlined" class="rounded-xl">
                        <v-card-text class="pa-0">
                          <v-table density="compact" class="ai-attempts-table">
                            <thead>
                              <tr>
                                <th class="text-center" style="width: 20px">#</th>
                                <th class="text-left" style="width: 180px">Attempt</th>
                                <th class="text-left">Endpoint</th>
                                <th class="text-center" style="width: 80px">Priority</th>
                                <th class="text-center" style="width: 100px">Result</th>
                                <th class="text-center" style="width: 100px">Response Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(attempt, idx) in monitorData.AiAttempts" :key="`${attempt.AttemptOrder}-${idx}`">
                                <td class="text-center">
                                  <v-chip size="x-small" color="primary" variant="flat" label>
                                    {{ attempt.AttemptOrder || idx + 1 }}
                                  </v-chip>
                                </td>
                                <td>
                                  <div class="text-body-2 font-weight-medium d-flex align-center">
                                    <v-icon size="16" color="primary" class="mr-1">mdi-robot</v-icon>
                                    {{ attempt.ModelName || '-' }}
                                  </div>
                                  <div class="text-caption text-grey">{{ formatAiAttemptTimestamp(attempt) }}</div>
                                </td>
                                <td>
                                  <div 
                                    class="endpoint-text clickable-text" 
                                    :title="attempt.EndpointUrl || '-'"
                                    @click="copyToClipboard(attempt.EndpointUrl)"
                                    style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; cursor: pointer;"
                                  >
                                    {{ attempt.EndpointUrl || '-' }}
                                    <v-icon size="14" class="ml-1">mdi-content-copy</v-icon>
                                  </div>
                                </td>
                                <td class="text-center">
                                  <v-chip v-if="formatAiAttemptPriority(attempt) !== '-'" size="x-small" color="indigo" variant="outlined">
                                    {{ formatAiAttemptPriority(attempt) }}
                                  </v-chip>
                                  <span v-else>-</span>
                                </td>
                                <td class="text-center">
                                  <v-chip size="x-small" :color="getAiAttemptStatusColor(attempt)" variant="flat" class="text-white">
                                    <v-icon size="12" color="white" class="mr-1">{{ getAiAttemptStatusIcon(attempt) }}</v-icon>
                                    {{ getAiAttemptStatus(attempt) }}
                                  </v-chip>
                                </td>
                                <td class="text-center">
                                  <v-chip
                                    size="x-small"
                                    :color="getResponseTimeColor(attempt.ResponseTimeMs)"
                                    variant="flat"
                                    class="text-white"
                                  >
                                    {{ formatAiAttemptResponseTime(attempt) }}
                                  </v-chip>
                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </v-card-text>
                      </v-card>
                    </div>
                    <div v-else class="text-center py-4">
                      <v-icon size="32" color="grey-lighten-1">mdi-robot-off</v-icon>
                      <p class="mt-2 text-grey text-caption">No AI attempt data captured for this log.</p>
                    </div>
                  </v-card-text>
                </v-expand-transition>
              </v-card>
            </div>
          </div>

          <!-- No Data State -->
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey-lighten-1">mdi-monitor-off</v-icon>
            <h3 class="mt-4 text-grey">No Monitor Data Available</h3>
          </div>
        </v-card-text>

        <v-card-actions class="flow-dialog-footer">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" class="flow-dialog-close-btn" color="#C30000" @click="dialogMonitor = false">
            <v-icon class="mr-2" size="25" color="#C30000">mdi-close</v-icon>
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import checkPermissionTwo from '@/api/function.js';
import LogTrace from '@/api/function.js';
import monitorDialogModelIcon from "@/assets/Icons/monitor-detail-model.svg";
import monitorDialogSystemIcon from "@/assets/Icons/monitor-detail-system-prompt.svg";
import monitorDialogKnowledgeIcon from "@/assets/Icons/monitor-detail-knowledge.svg";
import monitorDialogMemoryIcon from "@/assets/Icons/monitor-detail-memory.svg";
import monitorDialogModelConfigIcon from "@/assets/Icons/monitor-detail-modelConfig.svg";
import monitorEndpointUrlIcon from "@/assets/Icons/material-symbols_api.svg";
import monitorContentRequestBodyIcon from "@/assets/Icons/content-request-body.svg";
import chatlogImg from '@/assets/images/chatlog.svg';

export default {
  name: 'LogMessage',
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    showSelect: false,
    showSelectType: false,
    isInitialized: false,
    selectedOption: null,
    selectedOptionQSName: null,
    selectedOptionQSValue: null,
    QuestionSetName: '',
    dropdownItems: [],
    dropdownItemsQSType: [
      {
        name: 'Normal Question',
        value: 'P',
      },
      {
        name: 'Chain Question',
        value: 'C',
      },
    ],
    isAddingData: false,
    appliedFilters: {
      userChannel: null,
      sessionID: null,
    },
    userChannel: null,
    sessionID: null,
    checkbox1: false,
    dialog: false,
    dialogExportQS: false,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    tableLoading: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },

    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    type: 'Token',

    detailsExpanded: false,
    DDModelShow: [],
    searchModelName: '',
    isSearch: false,
    isFirst: true,
    dataTable: [],
    type_options: [
      { value: 'Token', name: 'Token Usage' },
      { value: 'Chat', name: 'Chat Log' },
      { value: '', name: 'Raw Log' },
      { value: 'SQL', name: 'SQL Log' },
      { value: 'Intent', name: 'Intent Log' },
      { value: 'Error', name: 'Error Log' },
      { value: 'FD', name: 'Memory Debugger' },
    ],
    ShowAllText: false,
    CheckboxShowAllText: false,
    dialogFlow: false,
    dialogMonitor: false,
    monitorData: null,
    loadingMonitor: false,
    logFlowDataTemp: null,
    expandedStep: null,
    flowHasOverflow: false,
    monitorIcons: {
      model: monitorDialogModelIcon,
      system: monitorDialogSystemIcon,
      knowledge: monitorDialogKnowledgeIcon,
      memory: monitorDialogMemoryIcon,
      modelConfig: monitorDialogModelConfigIcon,
      endPointUrl: monitorEndpointUrlIcon,
      contentRequestBody: monitorContentRequestBodyIcon,
    },
    images: {
      chatlog: chatlogImg,
    },
    monitorPanelExpanded: {
      system: false,
      knowledge: false,
      database: false,
      memory: false,
      modelConfig: false,
      aiAttempts: false,
    },
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'center',
          width: '100px',
          sortable: false,
        },
        {
          title: 'Flow',
          align: 'center',
          sortable: false,
          width: '120px',
        },
        { title: 'Input Message', align: 'center', sortable: false, width: '500px', minWidth: '300px' },
        {
          title: 'Output Message',
          align: 'center',
          sortable: false,
          width: '500px',
          minWidth: '300px',
        },
        { title: 'System Message', align: 'center', sortable: false, width: '500px', minWidth: '300px' },
        { title: 'Knowledge', align: 'center', sortable: false, width: '500px' },
        { title: 'Logs ID', align: 'center', sortable: false, width: '500px' },
        { title: 'Session ID', align: 'center', sortable: false, width: '500px' },
        { title: this.$t('modelID'), align: 'center', sortable: false, width: '200px' },
        { title: this.$t('modelName'), align: 'center', sortable: false, width: '200px' },
        { title: 'User Channel', align: 'center', sortable: false, width: '80px' },
        { title: 'Create Date', align: 'center', sortable: false, width: '200px' },
        { title: 'Response Time (ms)', align: 'center', sortable: false, width: '80px' },
      ];
    },
    questionSetLabel() {
      if (this.isAddingData) {
        return this.QuestionSetName || 'New Question Set Name';
      }
      return this.selectedOption || 'Select Question Set';
    },
    questionTypeLabel() {
      return this.selectedOptionQSName || 'Question Type';
    },

    //View Flow Dialog.....
    flowSteps() {
      // Support both array format and object with steps property
      if (!this.logFlowDataTemp) return [];
      if (Array.isArray(this.logFlowDataTemp)) return this.logFlowDataTemp;
      if (this.logFlowDataTemp.steps && Array.isArray(this.logFlowDataTemp.steps)) {
        return this.logFlowDataTemp.steps;
      }
      return [];
    },
    groupedFlowSteps() {
      const steps = this.flowSteps;
      if (!steps || steps.length === 0) return [];

      // Group steps by stepId
      const grouped = {};
      steps.forEach((step) => {
        if (!grouped[step.stepId]) {
          grouped[step.stepId] = [];
        }
        grouped[step.stepId].push(step);
      });

      // Convert to array format with stepId order preserved
      const result = [];
      const processedStepIds = new Set();

      steps.forEach((step) => {
        if (!processedStepIds.has(step.stepId)) {
          processedStepIds.add(step.stepId);
          const groupSteps = grouped[step.stepId];

          // Sort steps: main action (with next) first, then parallel actions
          const sortedSteps = [...groupSteps].sort((a, b) => {
            const aHasNext = a.next && Array.isArray(a.next) && a.next.length > 0;
            const bHasNext = b.next && Array.isArray(b.next) && b.next.length > 0;

            if (aHasNext && !bHasNext) return -1;
            if (!aHasNext && bHasNext) return 1;
            return 0;
          });

          // Determine if there's a main action
          const hasMainAction = sortedSteps.some((s) => s.next && Array.isArray(s.next) && s.next.length > 0);

          result.push({
            stepId: step.stepId,
            order: step.order,
            steps: sortedSteps,
            isParallel: groupSteps.length > 1,
            hasMainAction: hasMainAction,
          });
        }
      });

      return result;
    },
    //End View Flow Dialog.....
  },
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
    groupedFlowSteps: {
      handler() {
        // Re-check overflow when flow steps change
        this.$nextTick(() => {
          setTimeout(() => {
            this.checkFlowOverflow();
          }, 100);
        });
      },
      deep: true,
    },
  },
  methods: {
    getFormattedHeaderDate(year, month, selectedDate) {
      let date;

      if (selectedDate) {
        const selected = new Date(selectedDate);
        if (selected.getFullYear() === year && selected.getMonth() === month) {
          date = selected;
        } else {
          date = new Date(year, month, new Date().getDate());
        }
      } else {
        const today = new Date();
        if (today.getFullYear() === year && today.getMonth() === month) {
          date = today;
        } else {
          date = new Date(year, month, 1);
        }
      }

      const options = { weekday: 'short', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },

    formatDate(dateInput) {
      if (!dateInput) {
        return '';
      }
      if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const date = `${year}-${month}-${day}`;
      return date;
    },
    GetDDValidationPositive() {
      let self = this;
      if (self.dropdownItems != null && self.dropdownItems.length > 0) {
        return;
      }
      self.dialog = true;
      self.$call.GetValidationPositiveDD2(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.dropdownItems = dataResponse.data;
            self.dropdownItems.push({ name: 'New Question Set Name' });
          } else {
            self.dropdownItems = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    handleQuestionSetSelect(item) {
      const value = item?.name ?? '';
      this.selectedOption = value;

      if (value === 'New Question Set Name') {
        this.isAddingData = true;
        this.QuestionSetName = '';
      } else {
        this.QuestionSetName = value;
        this.isAddingData = false;
      }

      this.showSelect = false;
    },
    handleQuestionTypeSelect(item) {
      if (!item) {
        return;
      }

      this.selectedOptionQSName = item.name;
      this.selectedOptionQSValue = item.value ?? item.name;
      this.showSelectType = false;
    },
    handleSelectChange1(value, name) {
      this.selectedOptionQSName = value;
      this.selectedOptionQSNameTxt = name;
    },
    filterClick() {
      this.detailsExpanded = !this.detailsExpanded;
    },
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.Get();
    },
    applyFilter() {
      let self = this;
      self.isSearch = true;
      self.appliedFilters.userChannel = self.userChannel;
      self.appliedFilters.sessionID = self.sessionID;
      self.options.page = 1;
      self.Get();
    },
    clearFilters() {
      this.userChannel = null;
      this.sessionID = null;
      this.appliedFilters.userChannel = null;
      this.appliedFilters.sessionID = null;
      this.options.page = 1;
      this.Get();
    },

    GetForDownload() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { page, itemsPerPage } = this.options;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type,
      };
      self.$call.GetTableLogMessage(
        temp,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            temp.page = 1;
            temp.perPage = 1;

            let array = [
              [
                '\ufeffID',
                '\ufeffTEXT',
                '\ufeffreplymsg',
                '\ufeffPrompt',
                '\ufeffshortmemory',
                '\ufeffTYPE_SEND',
                '\ufeffModel ID',
                '\ufeffModel name',
                '\ufeffUSER_CHANNEL',
                '\ufeffCreateDate',
                '\ufeffCreateBy',
                '\ufeffGUID',
                '\ufeffIsRead',
                '\ufeffPrompt_tokens',
                '\ufeffCompletion_tokens',
                '\ufeffTotal_tokens',
                '\ufeffModel',
                '\ufeffPollScore',
                '\ufeffintent',
                '\ufeffResponse_time(ms)',
              ],
            ];

            const total_max = dataResponse.data.total;
            let tasks = [];
            let i = 1;
            while (i <= total_max) {
              tasks.push(i);
              i++;
              // Simulate an asynchronous operation (e.g., API call) with a delay
              await new Promise((resolve) => setTimeout(resolve, 100));
            }
            // Ex. let tasks = [1,2,3,4,5,6,7,8,9,10];
            for (const index of tasks) {
              temp.page = index;
              await new Promise((resolve) => setTimeout(resolve, 100));
              await self.$call.GetTableLogMessage(temp, async (dataResponse) => {
                if (dataResponse.status == 0) {
                  let datas = dataResponse.data.data;
                  let conut = dataResponse.data.page;
                  // for (let index = 0; index < datas.length; index++) {
                  for (const data of datas) {
                    // const data = datas[index_1];
                    array.push([
                      data.id,
                      data.text,
                      data.replymsg,
                      data.prompt,
                      data.shortmemory,
                      data.typE_SEND,
                      data.modelDisplay,
                      data.modelName,
                      data.userChannel,
                      data.createDate,
                      data.createBy,
                      data.guid,
                      data.isRead,
                      data.prompt_tokens,
                      data.completion_tokens,
                      data.total_tokens,
                      data.model,
                      data.pollScore,
                      data.intent,
                      data.responseTimeStr,
                    ]);
                    await new Promise((resolve) => setTimeout(resolve, 100));

                    if (conut == total_max) {
                      let str = '';
                      for (const item of array) {
                        let line = '';
                        line = item.join(',');
                        str += line + '\r\n';
                      }
                      let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
                      let link = document.createElement('a');
                      let url = URL.createObjectURL(blob);
                      link.setAttribute('href', url);
                      link.setAttribute('download', `LogMessage_${self.convertDateToString(new Date(), '')}.csv`);
                      link.style.visibility = 'hidden';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      //
                      self.dialog = false;
                      self.isSearch = false;
                      self.isFirst = false;
                    }
                  }
                }
              });
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetExportLogMonitoring() {
      let self = this;
      self.dialog = true;
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.GetExportLogMonitoring(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `LogMonitoring__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ExportQuestionSet() {
      let self = this;
      self.dialog = true;
      if (
        self.selectedOption == null || self.selectedOptionQSName == null ||
        (
          (self.selectedOption == "New Question Set Name")
          && (self.QuestionSetName == null || self.QuestionSetName == undefined || self.QuestionSetName == "")
        )
      ) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningFillAll'),
          showConfirmButton: false,
          timer: 3000,
        });
        self.dialog = false;
        return;
      }
      else if (self.selectedOption == "New Question Set Name") {
        self.selectedOption = self.QuestionSetName;
      }
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        // Name: self.QuestionSetName,
        Name: self.selectedOption,
        QuestionType: self.selectedOptionQSValue ?? self.selectedOptionQSName,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.ExportQuestionSet(
        req,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              title: "✔ Successfully Saved !",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            self.dialogExportQS = false;
            self.selectedOption = null;
            self.selectedOptionQSName = null;
            self.selectedOptionQSValue = null;
            self.QuestionSetName = '';
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetExportLog() {
      let self = this;
      self.dialog = true;
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.GetExportLog(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `Log__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ExportFileQuestionSet() {
      let self = this;
      self.dialog = true;
      if (self.selectedOptionQSName == null) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: "Please select a Question Set Type.",
          showConfirmButton: false,
          timer: 3000,
        });
        self.dialog = false;
        return;
      }
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        Name: self.QuestionSetName,
        QuestionType: self.selectedOptionQSValue ?? self.selectedOptionQSName,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.ExportFileQuestionSet(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `LogExportQuestionSet__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },

    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },
    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
    download() {
      const data = [];
      data.push('no,Text,Reply message,Prompt,Model Id,Model name,User channel,Create date\n');

      const a = document.createElement('a');
      let blob = new Blob(data, { type: 'data:text/csv;charset=BOM_UTF8' });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = 'upload_vector.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    substringLong(value) {
      if (value == null) {
        return '-';
      }
      if (value.length > 4000) {
        return value.substring(0, 3999) + '.....';
      }
      return value;
    },
    normalizeText(value) {
      if (value === null || value === undefined) {
        return '';
      }
      const raw = String(value);
      const withoutTags = raw.replace(/<[^>]*>/g, ' ');
      return withoutTags.replace(/\s+/g, ' ').trim();
    },
    hasExpandableContent(value) {
      if (value === null || value === undefined) {
        return false;
      }
      const raw = String(value);
      const normalized = this.normalizeText(raw);
      if (!normalized || normalized === '-') {
        return false;
      }
      if (normalized.length > 140) {
        return true;
      }
      return /(\n|<br\s*\/?>)/i.test(raw);
    },
    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },

    Get() {
      let self = this;
      self.dialog = true;
      self.tableLoading = true;
      const { page, itemsPerPage } = this.options;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type,
        UserChannel: self.appliedFilters.userChannel == '' ? null : self.appliedFilters.userChannel,
        SessionID: self.appliedFilters.sessionID == '' ? null : self.appliedFilters.sessionID,
      };
      self.$call.GetTableLogMessage(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            this.options.page = dataResponse.data.page;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
          self.dataTable.forEach((element) => {
            element.show = self.ShowAllText;
            element.replyHasMore = self.hasExpandableContent(element.replymsg);
            element.promptHasMore = self.hasExpandableContent(element.prompt);
          });
          self.tableLoading = false;
        },
        (errorResource) => {
          self.tableLoading = false;
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    // Flow Dialog Methods
    openFlowDialog(item) {
      // Load flow data
      this.logFlowDataTemp = item.chatWorkFlow;

      // Reset to show instruction panel
      this.expandedStep = null;

      this.dialogFlow = true;

      // Check for overflow after dialog opens and content renders
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkFlowOverflow();
        }, 300); // Give time for dialog animation and content rendering
      });
    },

    checkFlowOverflow() {
      const flowContainer = document.querySelector('.horizontal-flow-steps');
      if (flowContainer) {
        // Check if content width exceeds container width (has horizontal scroll)
        this.flowHasOverflow = flowContainer.scrollWidth > flowContainer.clientWidth;
      }
    },

    formatNodeName(nodeName) {
      const nodeNames = {
        messageInput: 'Message Input',
        intent: 'Intent Router',
        model: 'AI Model',
        aiModel: 'AI Model Processing',
        interestOptimizer: 'Interest Optimizer',
        response: 'Message Output',
        apiknowledge: 'API Knowledge',
        databaseIntegration: 'DB Integration',
        apiTrigger: 'API Trigger',
        contactAgent: 'Contact Agent',
        loanInterest: 'Loan Interest',
        documents: 'Documents',
        embedding: 'Vector Embedding',
        queryRewriter: 'Query Rewriter',
        smartIntent: 'Smart Intent',
        advancedRouter: 'Advanced Router',
        merge: 'Merge Results',
      };
      return nodeNames[nodeName] || nodeName;
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        return new Date(dateTime).toLocaleString();
      } catch (e) {
        return dateTime;
      }
    },

    getStepStatusClass(status) {
      return `flow-step-${status}`;
    },

    getNodeIcon(nodeType) {
      const icons = {
        messageInput: 'mdi-message-text',
        intent: 'mdi-router',
        model: 'mdi-robot',
        aiModel: 'mdi-robot',
        interestOptimizer: 'mdi-calculator',
        response: 'mdi-message-reply-text',
        apiknowledge: 'mdi-rocket-launch',
        databaseIntegration: 'mdi-database-search',
        apiTrigger: 'mdi-rocket-launch',
        contactAgent: 'mdi-account-supervisor',
        loanInterest: 'mdi-home-analytics',
        documents: 'mdi-file-document-multiple',
        embedding: 'mdi-code-array',
        smartIntent: 'mdi-robot-confused',
        advancedRouter: 'mdi-source-branch',
        queryRewriter: 'mdi-message-text-clock-outline',
        merge: 'mdi-merge',
      };
      return icons[nodeType] || 'mdi-circle';
    },

    getNodeTypeColor(nodeType) {
      const colors = {
        messageInput: '#22c55e', // Green
        intent: '#8b5cf6', // Purple
        model: '#3b82f6', // Blue
        aiModel: '#3b82f6', // Blue
        interestOptimizer: '#f59e0b', // Amber
        response: '#f97316', // Orange
        apiknowledge: '#ff6c37', // Orange
        databaseIntegration: '#16a34a', // Green
        apiTrigger: '#0ea5e9', // Sky Blue
        contactAgent: '#dc2626', // Red
        loanInterest: '#10b981', // Emerald
        documents: '#0369a1', // Blue
        embedding: '#14b8a6', // Teal
        smartIntent: '#4f46e5', // Indigo
        advancedRouter: '#8b5cf6', // Purple
        queryRewriter: '#7c3aed', // Violet
        merge: '#06b6d4', // Cyan
      };
      return colors[nodeType] || '#6b7280';
    },

    getNodeIconGradient(nodeType) {
      const gradients = {
        intent: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        model: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        interestOptimizer: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        apiknowledge: 'linear-gradient(135deg, #ff6c37 0%, #ff5722 100%)',
        databaseIntegration: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
        apiTrigger: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
        contactAgent: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
        loanInterest: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        documents: 'linear-gradient(135deg, #0369a1 0%, #075985 100%)',
        embedding: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
        smartIntent: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)',
        advancedRouter: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
        queryRewriter: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
        merge: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
      };
      return gradients[nodeType] || 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)';
    },

    getResponseTimeColor(responseTimeMs) {
      // Color coding based on response time
      if (!responseTimeMs) return '#6b7280'; // Gray for no data
      const ms = parseInt(responseTimeMs);
      if (ms < 2000) return '#10b93d'; // Green - Fast
      if (ms < 5000) return '#3b82f6'; // Blue - Normal
      if (ms < 10000) return '#f59e0b'; // Amber - Moderate
      if (ms < 20000) return '#f97316'; // Orange - Slow
      return '#ef4444'; // Red - Very slow
    },

    formatTime(dateTime) {
      if (!dateTime) return '-';
      try {
        return new Date(dateTime).toLocaleTimeString();
      } catch (e) {
        return dateTime;
      }
    },

    // AI Attempts helper methods
    formatAiAttemptTimestamp(attempt) {
      if (!attempt || !attempt.TimestampUtc) return '-';
      try {
        return new Date(attempt.TimestampUtc).toLocaleString();
      } catch {
        return attempt.TimestampUtc;
      }
    },
    formatAiAttemptPriority(attempt) {
      if (!attempt) return '-';
      if (attempt.Priority !== undefined && attempt.Priority !== null) {
        return `P${attempt.Priority}`;
      }
      if (attempt.PriorityDisplay !== undefined && attempt.PriorityDisplay !== null) {
        return `P${attempt.PriorityDisplay}`;
      }
      return '-';
    },
    formatAiAttemptResponseTime(attempt) {
      if (!attempt || attempt.ResponseTimeMs === undefined || attempt.ResponseTimeMs === null) {
        return '-';
      }
      const value = Number(attempt.ResponseTimeMs);
      if (Number.isNaN(value)) return '-';
      return `${value >= 100 ? value.toFixed(0) : value.toFixed(2)} ms`;
    },
    getAiAttemptStatus(attempt) {
      if (!attempt) return 'Unknown';
      const statusReturn = typeof attempt.StatusReturn === 'number' ? attempt.StatusReturn : null;
      if (attempt.Success === true || statusReturn === 0) {
        return 'Success';
      }
      if (attempt.Success === false || (statusReturn !== null && statusReturn !== 0)) {
        return 'Failed';
      }
      return 'Unknown';
    },
    getAiAttemptStatusColor(attempt) {
      const status = this.getAiAttemptStatus(attempt);
      if (status === 'Success') return 'success';
      if (status === 'Failed') return 'error';
      return 'warning';
    },
    getAiAttemptStatusIcon(attempt) {
      const status = this.getAiAttemptStatus(attempt);
      if (status === 'Success') return 'mdi-check-circle';
      if (status === 'Failed') return 'mdi-alert-circle';
      return 'mdi-help-circle';
    },

    isStepSelected(step) {
      if (!this.expandedStep || !step) return false;
      // Compare by reference or create a unique identifier
      return (
        this.expandedStep === step ||
        (this.expandedStep.stepId === step.stepId &&
          this.expandedStep.node === step.node &&
          this.expandedStep.startTime === step.startTime &&
          this.expandedStep.endTime === step.endTime &&
          this.expandedStep.responseTimeMs === step.responseTimeMs)
      );
    },

    async toggleStepDetails(step) {
      if (!step) return;

      // Toggle expanded state (check if same step)
      if (this.isStepSelected(step)) {
        this.expandedStep = null;
      } else {
        this.expandedStep = step;

        // Fetch log references if available
        if (step.logRefs && Array.isArray(step.logRefs) && step.logRefs.length > 0 && step.node !== 'documents') {
          // Set loading state (Vue 3 style - direct assignment)
          step.loadingRefs = true;
          step.logRefsData = null;
          step.logRefsError = null;

          try {
            const request = {
              ID: step.logRefs, // Array of log IDs
              Node: step.node, // Node type (optional)
            };

            this.$call.GetLogReferenceFromLog(
              request,
              (response) => {
                // Data is in response.result array
                if (response && response.data.result && Array.isArray(response.data.result)) {
                  step.logRefsData = response.data.result; // Use only the result array
                  // Force reactivity update by reassigning expandedStep
                  this.expandedStep = { ...step };
                } else if (response && response.data && Array.isArray(response.data)) {
                  step.logRefsData = response.data;
                  // Force reactivity update by reassigning expandedStep
                  this.expandedStep = { ...step };
                }
                step.loadingRefs = false;
                // Force reactivity update
                this.expandedStep = { ...step };
              },
              (error) => {
                console.error('Error fetching log references:', error);
                step.logRefsError = 'Failed to load reference data';
                step.loadingRefs = false;
                // Force reactivity update
                this.expandedStep = { ...step };
              }
            );
          } catch (error) {
            console.error('Error fetching log references:', error);
            step.logRefsError = 'Failed to load reference data';
            step.loadingRefs = false;
          }
        } else if (step.node === 'documents') {
          var docLogIds = step.output.message ? JSON.parse(step.output.message) : null;
          if (docLogIds && Array.isArray(docLogIds) && docLogIds.length > 0) {
            step.logRefs = docLogIds;
          }
          
          // Only call API if logRefs exists and has data
          if (step.logRefs && Array.isArray(step.logRefs) && step.logRefs.length > 0) {
            // Set loading state (Vue 3 style - direct assignment)
            step.loadingRefs = true;
            step.logRefsData = null;
            step.logRefsError = null;

            try {
              const request = {
                ID: step.logRefs
              };

              this.$call.GetLogDocumentReferenceFromLog(
                request,
                (response) => {
                  // Data is in response.result array
                  if (response && response.data.result && Array.isArray(response.data.result)) {
                    step.logRefsData = response.data.result; // Use only the result array
                    // Force reactivity update by reassigning expandedStep
                    this.expandedStep = { ...step };
                  } else if (response && response.data && Array.isArray(response.data)) {
                    step.logRefsData = response.data;
                    // Force reactivity update by reassigning expandedStep
                    this.expandedStep = { ...step };
                  }
                  step.loadingRefs = false;
                  // Force reactivity update
                  this.expandedStep = { ...step };
                },
                (error) => {
                  console.error('Error fetching log references:', error);
                  step.logRefsError = 'Failed to load reference data';
                  step.loadingRefs = false;
                  // Force reactivity update
                  this.expandedStep = { ...step };
                }
              );
            } catch (error) {
              console.error('Error fetching log references:', error);
              step.logRefsError = 'Failed to load reference data';
              step.loadingRefs = false;
            }
          }
        }

        // Smooth scroll to details panel after expansion animation
        this.$nextTick(() => {
          setTimeout(() => {
            const detailsPanel = document.querySelector('.step-details-panel');
            if (detailsPanel) {
              detailsPanel.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest',
              });
            }
          }, 200);
        });
      }

      // Update step expanded property for UI
      step.expanded = !step.expanded;
    },

    // Open monitor details dialog with real API call
    openMonitorDetails(id, nodeType, logRouterID = null) {
      // Reset and open dialog
      this.monitorData = null;
      this.loadingMonitor = true;
      this.dialogMonitor = true;

      const request = {
        ID: id,
        Node: nodeType,
        LogRouterID: logRouterID,
      };

      this.$call.GetLogMonitorFromLog(
        request,
        (response) => {
          try {
            // Parse jsonMonitor (similar to replymsg in Stream.vue)
            let parsedMonitor = null;
            if (response.data.jsonMonitor) {
              // console.log('Raw jsonMonitor:', response.data.jsonMonitor);
              parsedMonitor = JSON.parse(response.data.jsonMonitor);
              // Clean up newlines like in Stream.vue
              if (parsedMonitor.Vector) {
                parsedMonitor.Vector = this.Replace_NewLine(parsedMonitor.Vector);
              }
              if (parsedMonitor.VectorCoise) {
                parsedMonitor.VectorCoise = this.Replace_NewLine(parsedMonitor.VectorCoise);
              }
              if (parsedMonitor.Private_Memory) {
                parsedMonitor.Private_Memory = this.Replace_NewLine(parsedMonitor.Private_Memory);
              }
            }

            let parsedMemory = null;
            const rawJsonMemory = response.data.jsonMemory;
            if (rawJsonMemory) {
              const trimmedMemory = typeof rawJsonMemory === 'string' ? rawJsonMemory.trim() : rawJsonMemory;
              const looksLikeJson = typeof trimmedMemory === 'string' && (trimmedMemory.startsWith('[') || trimmedMemory.startsWith('{'));

              if (looksLikeJson) {
                try {
                  const memoryArray = JSON.parse(trimmedMemory);
                  if (Array.isArray(memoryArray) && memoryArray.length > 0) {
                    parsedMemory = '';
                    for (let i = 0; i < memoryArray.length; i++) {
                      parsedMemory += `${i + 1}. ${memoryArray[i].role} : ${memoryArray[i].content}\n`;
                    }
                  }
                } catch (parseError) {
                  // Fallback to raw string when parsing fails (e.g. "NotFound" message)
                  parsedMemory = trimmedMemory;
                }
              } else {
                parsedMemory = trimmedMemory;
              }
            }
            // Build DataLog structure like in Stream.vue
            this.monitorData = {
              Prompt: parsedMonitor?.GPT_Model?.promptTemplate || '',
              Vector: parsedMonitor?.Vector || '',
              ReplySQL: parsedMonitor?.ReplySQL || '',
              ReplyDataSelect: parsedMonitor?.ReplyDataSelect || '',
              Memory: parsedMemory || '',
              JsonMemoryRaw: rawJsonMemory || '',
              Translate: parsedMonitor?.Translate || '',
              FlowActionIntent: parsedMonitor?.FlowActionIntent || '',
              ContentRequest: response.data.contentRequest || '',
              GPT_Model: {
                ModelID: parsedMonitor?.GPT_Model?.ModelID || '',
                ModelName: parsedMonitor?.GPT_Model?.ModelName || '',
                Provider: parsedMonitor?.GPT_Model?.Provider || '',
                Model: parsedMonitor?.GPT_Model?.Model || '',
                Extension: parsedMonitor?.GPT_Model?.Extension || '',
                Description: parsedMonitor?.GPT_Model?.Description || '',
                promptTemplate: parsedMonitor?.GPT_Model?.promptTemplate || '',
                gender: parsedMonitor?.GPT_Model?.gender || '',
                vectordbName: parsedMonitor?.GPT_Model?.vectordbName || '',
                TopVDB: parsedMonitor?.GPT_Model?.TopVDB || '',
                internet: parsedMonitor?.GPT_Model?.internet || '',
                feedback: parsedMonitor?.GPT_Model?.feedback || '',
                HistoryCount: parsedMonitor?.GPT_Model?.HistoryCount || '',
                HistoryMinute: parsedMonitor?.GPT_Model?.HistoryMinute || '',
                temperature: parsedMonitor?.GPT_Model?.temperature || '',
                top_p: parsedMonitor?.GPT_Model?.top_p || '',
                frequency_penalty: parsedMonitor?.GPT_Model?.frequency_penalty || '-',
                presence_penalty: parsedMonitor?.GPT_Model?.presence_penalty || '-',
                Stop: parsedMonitor?.GPT_Model?.Stop || '',
                max_tokens: parsedMonitor?.GPT_Model?.max_tokens || '',
                IsStream: parsedMonitor?.GPT_Model?.IsStream || '',
                EndpointURL: parsedMonitor?.GPT_Model?.EndpointURL || '',
              },
              Text: parsedMonitor?.GPT_Model?.TextVector || '',
              TextVector: parsedMonitor?.GPT_Model?.TextVector || '',
              VectorCoise: parsedMonitor?.VectorCoise || '',
              Private_Memory: parsedMonitor?.Private_Memory || '',
              AiAttempts: Array.isArray(parsedMonitor?.AiAttempts)
                ? parsedMonitor.AiAttempts.map((attempt, index) => ({
                    AttemptOrder: attempt?.AttemptOrder ?? index + 1,
                    IsRetry: attempt?.IsRetry ?? false,
                    TimestampUtc: attempt?.TimestampUtc,
                    Provider: attempt?.Provider || parsedMonitor?.GPT_Model?.Provider || '',
                    ModelName: attempt?.ModelName || parsedMonitor?.GPT_Model?.ModelName || '',
                    EndpointUrl: attempt?.EndpointUrl || '',
                    EndpointId: attempt?.EndpointId,
                    Priority: attempt?.Priority,
                    PriorityDisplay: attempt?.PriorityDisplay,
                    Success: attempt?.Success,
                    StatusReturn: attempt?.StatusReturn,
                    ResponseTimeMs: attempt?.ResponseTimeMs,
                    ReplyPreview: attempt?.ReplyPreview,
                  }))
                : [],
            };
            console.log('Parsed monitor data:', this.monitorData);
          } catch (error) {
            console.error('Error parsing monitor data:', error);
            // Set default empty structure on error
            this.monitorData = this.getEmptyMonitorData();
          }

          this.loadingMonitor = false;
        },
        (error) => {
          console.error('Error fetching monitor data:', error);
          this.monitorData = this.getEmptyMonitorData();
          this.loadingMonitor = false;
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to load monitor data',
            timer: 2000,
          });
        }
      );
    },

    getEmptyMonitorData() {
      return {
        Prompt: '',
        Vector: '',
        ReplySQL: '',
        ReplyDataSelect: '',
        Memory: '',
        JsonMemoryRaw: '',
        Translate: '',
        FlowActionIntent: '',
        ContentRequest: '',
        GPT_Model: {
          ModelID: '',
          ModelName: '',
          Provider: '',
          Model: '',
          Extension: '',
          Description: '',
          promptTemplate: '',
          gender: '',
          vectordbName: '',
          TopVDB: '',
          internet: '',
          feedback: '',
          HistoryCount: '',
          HistoryMinute: '',
          temperature: '',
          top_p: '',
          frequency_penalty: '-',
          presence_penalty: '-',
          Stop: '',
          max_tokens: '',
          IsStream: '',
          EndpointURL: '',
        },
        Text: '',
        TextVector: '',
        VectorCoise: '',
        Private_Memory: '',
        AiAttempts: [],
      };
    },

    Replace_NewLine(input) {
      try {
        if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
          input = input.slice(1, input.length);
        }
        if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
          input = input.slice(1, input.length);
        }
      } catch {
        // Do nothing on error
      }
      return input;
    },

    // Copy text to clipboard
    copyToClipboard(text) {
      if (!text || text === '-') return;

      // Modern approach
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$swal.fire({
              icon: 'success',
              title: 'Copied',
              text: 'copied to clipboard',
              timer: 2000,
              showConfirmButton: false,
              toast: true,
              position: 'top-end',
              showClass: {
                popup: 'swal2-noanimation',
              },
              hideClass: {
                popup: '',
              },
              customClass: {
                popup: 'professional-toast',
              },
            });
          })
          .catch((err) => {
            console.error('Failed to copy:', err);
          });
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$swal.fire({
            icon: 'success',
            title: 'Copied',
            text: 'copied to clipboard',
            timer: 2000,
            showConfirmButton: false,
            toast: true,
            position: 'top-end',
            showClass: {
              popup: 'swal2-noanimation',
            },
            hideClass: {
              popup: '',
            },
            customClass: {
              popup: 'professional-toast',
            },
          });
        } catch (err) {
          console.error('Failed to copy:', err);
        }
        document.body.removeChild(textArea);
      }
    },
    /* =============================================================================
    End View Flow LHB Version.....
    ============================================================================= */
  },
  mounted() {
    this.GetDate();
    this.startDate = this.convertDateToString2(new Date());
    this.endDate = this.convertDateToString2(new Date());
    this.appliedFilters = { userChannel: null, sessionID: null };
    this.Get();
    this.isInitialized = true;
  },
};
</script>
<style scoped>
/* =============================================================================
   CARD COMPONENTS
   ============================================================================= */

.heading-text {
  color: #171717;
  font-weight: 600;
}

hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}

.card2 {
  border: 1px solid rgba(201, 201, 201, 1) !important;
  border-radius: 10px !important;
  box-shadow: none;
  padding: 10px;
}

.card-title {
  color: #171717;
  font-weight: 600;
  font-size: 14px;
}

.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
}

.logType-select-input {
  background: white;
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
}

.logType-select-input :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}

.logType-select-input :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}

.logType-select-input :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}

.search-divider {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.search-btn {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  height: 36px;
  width: 36px;
  border-radius: 18px;
  margin-left: -8px;
}

.action-divider {
  width: 2px;
  height: 60px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
  transition: background-color 0.2s ease;
  margin-top: 16px;
}

.advance-filters {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 24px;
}

/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important;
  /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}

.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}

/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;

}

.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}

.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}

.v-input--density-default {
  --v-input-control-height: none;
}

.date-divider-style {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
}

.date-divider {
  color: #c9c9c9;
  font-weight: 700;
  margin-top: 37px;
  margin-left: 20px;
}

.clear-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 28px;
  gap: 8px;
  padding: 9px;
  border-radius: 10px;
}

.clear-button:hover {
  background: rgba(56, 89, 208, 0.1);
  border-radius: 10px;
}

.filter-by {
  color: #3859D0;
  font-size: 13px;
}

/* =============================================================================
   NEW SEARCH BUTTON STYLE
   ============================================================================= */


/* =============================================================================
   EXPANDABLE ADVANCED FILTERS CARD
   ============================================================================= */
.advanced-filter-expandable-card {
  background: transparent !important;
  border-radius: 16px !important;
  margin-bottom: 1.5rem;
  overflow: hidden;
  background: #ffffff !important;
  box-shadow: unset !important;
}

.expandable-card-header {
  background: linear-gradient(90deg, #FFF2F2 0%, #FFDED8 100%);
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 16px;
  transition: all 0.3s ease;
  user-select: none;
}

.expandable-card-header-expanded {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  color: #FFFFFF !important;
}

.expandable-card-header:hover {
  background: linear-gradient(90deg, #FFE8E8 0%, #FFD0C8 100%);
}

.expandable-card-header:focus {
  /* outline: 2px solid #667eea; */
  outline-offset: 2px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #171717;
}

.toggle-icon-btn {
  transition: transform 0.3s ease;
}

.card-content {
  background: #ffffff !important;
  box-shadow: unset !important;
  margin-top: 5px;
  border-radius: 16px !important;
  border: 1px solid rgba(201, 201, 201, 1) !important;
}

/* =============================================================================
   CLEAR FILTERS BUTTON
   ============================================================================= */
.clear-filters-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #3859D0;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.clear-filters-btn:hover {
  background: rgba(56, 89, 208, 0.1);
}

.action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -6px;
}

:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}

.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

.table-bottom-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.download-list-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 10px;
}

.download-list-item:hover {
  background: #CDD5F3;
}

.question-dialog {
  border-radius: 16px !important;
  background: #FFFFFF !important;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 20px;
}

.question-title {
  font-size: 16px;
  font-weight: 600;
  color: #171717;
}

.category-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 14px;
  margin: 3px 20px;
}

.footer-btn {
  border-radius: 12px;
  padding: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  gap: 10px;
}

.footer-btn.cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #949AA8;
  background: #ffffff;
  color: #646464;
  width: 100px;
}

.footer-btn.cancel:hover {
  background: #ebebef;
}

.footer-btn.save {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 8px;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  width: 100px;
}

.footer-btn.save span {
  color: #FFFFFF;
}

.date-card,
.filter-card,
.toggle-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.date-card:hover,
.filter-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.toggle-card {
  background: rgba(25, 118, 210, 0.05) !important;
}

.action-card {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02), rgba(25, 118, 210, 0.05)) !important;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
}

.advanced-filter-card {
  background: rgba(239, 244, 255, 0.5) !important;
  border-radius: 16px;
  box-shadow: none;
}

.data-table-card {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  overflow: hidden;
}

/* =============================================================================
   FORM ELEMENTS
   ============================================================================= */
.date-field .v-field {
  border-radius: 8px !important;
}

.section-title {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  border-bottom: 2px solid rgba(25, 118, 210, 0.2);
  padding-bottom: 8px;
}

/* =============================================================================
   BUTTONS
   ============================================================================= */
.download-btn-chat-log {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 120px;
  justify-content: center;
  align-items: center;
  padding: 9px;
  gap: 6px;
}

.download-btn-chat-log:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}

.download-menu {
  min-width: 226px;
  border-radius: 16px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  padding: 12px;
}

/* =============================================================================
   FILTER PANEL
   ============================================================================= */
.filter-panel-title {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05), rgba(25, 118, 210, 0.1)) !important;
  border-radius: 8px 8px 0 0 !important;
}

/* =============================================================================
   DATA TABLE
   ============================================================================= */
.table-container {
  overflow-x: auto;
  max-width: 20%;
  scrollbar-width: thin;
  scrollbar-color: #C9C9C9;
}

.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(210, 62, 25, 0.5);
}

.modern-table {
  border-radius: 0 0 12px 12px !important;
  min-width: 1200px;
}

.modern-table :deep(.v-data-table__th) {
  white-space: nowrap;
  min-width: 120px;
}

.modern-table :deep(.v-data-table__td) {
  min-width: 120px;
  max-width: 200px;
}

.table-row {
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}

/* =============================================================================
   TEXT CONTENT
   ============================================================================= */
.text-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 100px;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
  word-break: break-word;
}

.text-content-show {
  white-space: pre-wrap;
  word-break: break-word;
  flex-grow: 1;
  line-height: 1.4;
  max-width: 300px;
}

/* =============================================================================
   LAYOUT
   ============================================================================= */
.action-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 960px) {
  .action-group {
    flex-direction: column;
    width: 100%;
  }

  .d-flex.justify-space-between {
    flex-direction: column !important;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .modern-table {
    min-width: 800px;
  }

  .modern-table :deep(.v-data-table__th),
  .modern-table :deep(.v-data-table__td) {
    min-width: 100px;
    max-width: 150px;
  }

  .date-card,
  .filter-card,
  .toggle-card {
    margin-bottom: 12px;
  }
}

@media (max-width: 600px) {
  .section-title {
    font-size: 1rem;
  }

  .filter-section {
    margin-bottom: 24px;
  }
}

.dropdown-list {
  border-radius: 14px;
  margin-top: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  max-height: 200px;
  overflow-y: auto;

  /* Custom scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #C32E0E #f5f5f5;
}

/* Webkit browsers (Chrome, Safari, Edge) */
.dropdown-list::-webkit-scrollbar {
  width: 6px;
}

.dropdown-list::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 10px;
}

.dropdown-list::-webkit-scrollbar-thumb {
  background: #C32E0E;
  border-radius: 10px;
}

.dropdown-list::-webkit-scrollbar-thumb:hover {
  background: #F67760;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 15px;
  color: #171717;
  margin-bottom: 2px;
  white-space: pre-line;
  transition: background 0.2s ease;
}

.dropdown-item:hover {
  background: #f9f9f9;
}

.dropdown-item-active {
  background: #f5f5f5;
}
</style>

<!-- Redesign css -->
<style scoped>
.reportdata-filters-wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.reportdata-filter-card {
  background: transparent;
  border: 1px solid #C9C9C9;
  border-radius: 18px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.reportdata-field-date :deep(.v-field) {
  border-radius: 16px !important;
}

.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
  background: #ffffff;
}

.date-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #646464;
  font-weight: 700;
  font-size: 30px;
  padding-top: 20px;
  margin: 10px;
}

.reportdata-filter-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}

.log-flow-icon-btn {
  height: 40px;
  width: 40px;
  border-radius: 40px;
  background: rgba(195, 46, 14, 0.10);
  color: #C32E0E !important;
}

.dialog-info-card {
  border-radius: 16px !important;
  background: #FFF !important;
  box-shadow: 0 4px 22px 0 rgba(0, 0, 0, 0.16) !important;
}

.question-set-ddl {
  border-radius: 14px;
  margin-top: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>

<style scoped>
/* =============================================================================
  LHB VERSION DIALOG FLOW STYLE
  ============================================================================= */
/* Enhanced Dialog Styling */
.flow-dialog-card {
  border-radius: 22px !important;
  overflow: hidden;
  will-change: transform, opacity;
}

/* Optimize dialog transitions */
.v-dialog {
  will-change: transform, opacity;
}

.v-dialog--active {
  animation: dialogFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes dialogFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes shimmer {

  0%,
  100% {
    opacity: 0.3;
  }

  50% {
    opacity: 0.7;
  }
}

.flow-header-content {
  position: relative;
  z-index: 1;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #DCDCDC;
}

.flow-dialog-footer {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  border-top: 1px solid #DCDCDC;
}

.flow-dialog-close-btn {
  min-height: 42px;
  min-width: 120px;
  border-radius: 12px;
  color: #C30000;
  text-transform: none;
  border: 1px solid #C30000;
  background: transparent !important;
}

.flow-header-text {
  flex: 1;
}

.flow-title {
  font-size: 24px;
  font-weight: 600;
  color: #171717;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.flow-subtitle {
  font-size: 14px;
  color: #646464;
  margin: 0 0 0 12px;
  font-weight: 400;
}

.close-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
}

.close-btn i {
  color: white !important;
}

.flow-dialog-content {
  background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
  height: 70vh;
  min-height: 70vh;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  will-change: scroll-position;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.horizontal-flow-container {
  padding: 10px 24px;
  background: #FFF;
  contain: layout style paint;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

/* Scrollbar Styling */
.flow-dialog-content::-webkit-scrollbar {
  width: 8px;
}

.flow-dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.flow-dialog-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

.flow-dialog-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

/* Vertical line connecting parallel items - adjusted to not overflow */
.step-group-container.parallel-steps {
  position: relative;
  padding-left: 0;
}

.step-group-container.parallel-steps .step-item.parallel-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  width: 2px;
  background: #3b82f6;
  height: calc(100% + 12px);
  z-index: 0;
}

.step-group-container.parallel-steps .step-item.parallel-item:last-child::after {
  content: '';
  position: absolute;
  left: -20px;
  top: 0;
  width: 2px;
  background: #3b82f6;
  height: 50%;
  z-index: 0;
}

/* Checkpoint Node Styles */
.checkpoint-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  padding: 8px;
  min-width: 80px;
  max-width: 120px;
  border: 4px solid transparent !important;
  border-radius: 12px;
}

.checkpoint-node:hover {
  transform: translateY(-3px);
}

.checkpoint-node.active {
  transform: translateY(-3px) scale(1.05);
  border: 4px solid #10b981 !important;
  border-radius: 12px;
  box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.25), 0 0 20px rgba(16, 185, 129, 0.4);
  background: rgba(16, 185, 129, 0.08);
  animation: border-pulse 2s ease-in-out infinite;
}

@keyframes border-pulse {

  0%,
  100% {
    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.25), 0 0 15px rgba(16, 185, 129, 0.4);
  }

  50% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 10px rgba(16, 185, 129, 0.6);
  }
}

.checkpoint-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
}

.checkpoint-icon::before {
  content: '';
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.3);
  top: -4px;
  left: -4px;
  animation: checkpoint-pulse 2s infinite;
}

@keyframes checkpoint-pulse {
  0% {
    transform: scale(0.9);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }

  100% {
    transform: scale(0.9);
    opacity: 1;
  }
}

.checkpoint-label {
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
  line-height: 1.2;
}

.checkpoint-time-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
}

.checkpoint-time {
  font-size: 9px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-weight: 400;
}

.checkpoint-duration {
  font-size: 9px;
  color: white;
  text-align: center;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}


/* =============================================================================
   HORIZONTAL FLOW DIALOG STYLES
   ============================================================================= */
.horizontal-flow-container {
  width: 100%;
  will-change: auto;
}

.horizontal-flow-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  padding: 20px 10px;
  min-height: 200px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* When content overflows, align to flex-start to show beginning */
.horizontal-flow-steps.has-overflow {
  justify-content: flex-start;
}

.horizontal-step-wrapper {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  will-change: transform;
}

/* Step Group Container for Parallel Execution */
.step-group-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
}

.step-group-container.parallel-steps {
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
}

.step-item {
  display: flex;
  align-items: center;
}

.step-item.parallel-item {
  position: relative;
}

.step-item.parallel-item::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  width: 12px;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6 0%, transparent 100%);
  transform: translateY(-50%);
  z-index: 1;
}

/* Vertical line connecting parallel items - adjusted to not overflow */
.step-group-container.parallel-steps {
  position: relative;
  padding-left: 0;
}

.step-group-container.parallel-steps .step-item.parallel-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  width: 2px;
  background: #3b82f6;
  height: calc(100% + 12px);
  z-index: 0;
}

.step-group-container.parallel-steps .step-item.parallel-item:last-child::after {
  content: '';
  position: absolute;
  left: -20px;
  top: 0;
  width: 2px;
  background: #3b82f6;
  height: 50%;
  z-index: 0;
}

/* Checkpoint Node Styles */
.checkpoint-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  padding: 8px;
  min-width: 80px;
  max-width: 120px;
  border: 4px solid transparent !important;
  border-radius: 12px;
}

.checkpoint-node:hover {
  transform: translateY(-3px);
}

.checkpoint-node.active {
  transform: translateY(-3px) scale(1.05);
  border: 4px solid #10b981 !important;
  border-radius: 12px;
  box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.25), 0 0 20px rgba(16, 185, 129, 0.4);
  background: rgba(16, 185, 129, 0.08);
  animation: border-pulse 2s ease-in-out infinite;
}

@keyframes border-pulse {

  0%,
  100% {
    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.25), 0 0 15px rgba(16, 185, 129, 0.4);
  }

  50% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 10px rgba(16, 185, 129, 0.6);
  }
}

.checkpoint-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
}

.checkpoint-icon::before {
  content: '';
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.3);
  top: -4px;
  left: -4px;
  animation: checkpoint-pulse 2s infinite;
}

@keyframes checkpoint-pulse {
  0% {
    transform: scale(0.9);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }

  100% {
    transform: scale(0.9);
    opacity: 1;
  }
}

.checkpoint-label {
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
  line-height: 1.2;
}

.checkpoint-time-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
}

.checkpoint-time {
  font-size: 9px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-weight: 400;
}

/* Checkpoint Colors by Node Type */
.checkpoint-node[data-node-type='messageInput'] .checkpoint-icon {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}

.checkpoint-node[data-node-type='response'] .checkpoint-icon {
  background: linear-gradient(135deg, #f97316, #ea580c);
}

/* Selection Indicators - Hidden, use border instead */
.selection-indicator {
  display: none;
}

.card-selection-indicator {
  display: none;
}

.node-selection-indicator {
  display: none;
}

@keyframes pulse-select {

  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.4);
  }

  50% {
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(59, 130, 246, 0.6);
  }
}

/* Flow Node Styles - Minimal Style */
.flow-node {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  max-width: 180px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  cursor: pointer;
  border: 2px solid #e5e7eb;
  overflow: hidden;
}

.flow-node:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.12);
}

.flow-node.active {
  transform: translateY(-3px) scale(1.02);
  border: 4px solid #8b5cf6 !important;
  box-shadow: 0 0 0 6px rgba(139, 92, 246, 0.3), 0 0 20px rgba(139, 92, 246, 0.5);
  animation: border-pulse-purple 2s ease-in-out infinite;
}

@keyframes border-pulse-purple {

  0%,
  100% {
    box-shadow: 0 0 0 6px rgba(139, 92, 246, 0.3), 0 0 20px rgba(139, 92, 246, 0.5);
  }

  50% {
    box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.4), 0 0 30px rgba(139, 92, 246, 0.7);
  }
}

/* Node type-based colors using FlowNode.vue themes */
/* Message Input Node - Using message-node theme (green) */
.flow-node[data-node-type='messageInput'] {
  border: 5px solid #53ca7e !important;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%) !important;
  color: #166534 !important;
  box-shadow: 2px 6px 6px rgba(83, 202, 126, 0.699) !important;
}

/* Intent Node - Using intent-modern-node theme (purple) */
.flow-node[data-node-type='intent'] {
  border: 5px solid #c0a4ff !important;
  background: white !important;
  color: #1e293b !important;
  box-shadow: 2px 6px 6px rgba(145, 27, 255, 0.699) !important;
}

/* AI Model Node - Using ai-agent-node theme (blue) */
.flow-node[data-node-type='aiModel'] {
  border: 5px solid #3b82f6 !important;
  background: linear-gradient(135deg, #ffffff 0%, #eef5ff 100%) !important;
  color: #1e40af !important;
  box-shadow: 2px 6px 6px rgba(59, 130, 246, 0.699) !important;
}

/* Message Output Node - Using response-node theme (orange) */
.flow-node[data-node-type='messageOutput'] {
  border: 5px solid #f97316 !important;
  background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%) !important;
  color: #c2410c !important;
  box-shadow: 2px 6px 6px rgba(249, 115, 22, 0.699) !important;
}

/* API Knowledge Node - Orange theme */
.flow-card-node[data-node-type='apiknowledge'] {
  border: 2px solid #ffca98;
  box-shadow: 0 0 12px rgba(255, 108, 55, 0.6);
}

.flow-card-node[data-node-type='apiknowledge']:hover {
  border-color: #ffb367;
}

.flow-card-node[data-node-type='apiknowledge'].active {
  border: 2px solid #ff6c37 !important;
  box-shadow: 0 0 0 8px rgba(255, 108, 55, 0.35), 0 0 25px rgba(255, 108, 55, 0.6);
  animation: border-pulse-apiknowledge 2s ease-in-out infinite;
}

@keyframes border-pulse-apiknowledge {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(255, 108, 55, 0.35), 0 0 15px rgba(255, 108, 55, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(255, 108, 55, 0.45), 0 0 10px rgba(255, 108, 55, 0.8);
  }
}

/* Database Integration Node - Green theme */
.flow-card-node[data-node-type='databaseIntegration'] {
  border: 2px solid #67d89a;
  box-shadow: 0 0 12px rgba(22, 163, 74, 0.6);
}

.flow-card-node[data-node-type='databaseIntegration']:hover {
  border-color: #4ade80;
}

.flow-card-node[data-node-type='databaseIntegration'].active {
  border: 2px solid #16a34a !important;
  box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.35), 0 0 25px rgba(22, 163, 74, 0.6);
  animation: border-pulse-dbintegration 2s ease-in-out infinite;
}

@keyframes border-pulse-dbintegration {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.35), 0 0 15px rgba(22, 163, 74, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(22, 163, 74, 0.45), 0 0 10px rgba(22, 163, 74, 0.8);
  }
}

/* API Trigger Node - Sky Blue theme */
.flow-card-node[data-node-type='apiTrigger'] {
  border: 2px solid #75d3ff;
  box-shadow: 0 0 12px rgba(14, 165, 233, 0.6);
}

.flow-card-node[data-node-type='apiTrigger']:hover {
  border-color: #38bdf8;
}

.flow-card-node[data-node-type='apiTrigger'].active {
  border: 2px solid #0ea5e9 !important;
  box-shadow: 0 0 0 8px rgba(14, 165, 233, 0.35), 0 0 25px rgba(14, 165, 233, 0.6);
  animation: border-pulse-apitrigger 2s ease-in-out infinite;
}

@keyframes border-pulse-apitrigger {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(14, 165, 233, 0.35), 0 0 15px rgba(14, 165, 233, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(14, 165, 233, 0.45), 0 0 10px rgba(14, 165, 233, 0.8);
  }
}

/* Contact Agent Node - Red theme */
.flow-card-node[data-node-type='contactAgent'] {
  border: 2px solid #ff8282;
  box-shadow: 0 0 12px rgba(220, 38, 38, 0.6);
}

.flow-card-node[data-node-type='contactAgent']:hover {
  border-color: #f87171;
}

.flow-card-node[data-node-type='contactAgent'].active {
  border: 2px solid #dc2626 !important;
  box-shadow: 0 0 0 8px rgba(220, 38, 38, 0.35), 0 0 25px rgba(220, 38, 38, 0.6);
  animation: border-pulse-contactagent 2s ease-in-out infinite;
}

@keyframes border-pulse-contactagent {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(220, 38, 38, 0.35), 0 0 15px rgba(220, 38, 38, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(220, 38, 38, 0.45), 0 0 10px rgba(220, 38, 38, 0.8);
  }
}

/* Loan Interest Node - Emerald theme */
.flow-card-node[data-node-type='loanInterest'] {
  border: 2px solid #34d399;
  box-shadow: 0 0 12px rgba(16, 185, 129, 0.6);
}

.flow-card-node[data-node-type='loanInterest']:hover {
  border-color: #10b981;
}

.flow-card-node[data-node-type='loanInterest'].active {
  border: 2px solid #10b981 !important;
  box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 25px rgba(16, 185, 129, 0.6);
  animation: border-pulse-loaninterest 2s ease-in-out infinite;
}

@keyframes border-pulse-loaninterest {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 15px rgba(16, 185, 129, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(16, 185, 129, 0.45), 0 0 10px rgba(16, 185, 129, 0.8);
  }
}

/* Documents Node - Blue theme */
.flow-card-node[data-node-type='documents'] {
  border: 2px solid #76b2ff;
  box-shadow: 0 0 12px rgba(3, 105, 161, 0.6);
}

.flow-card-node[data-node-type='documents']:hover {
  border-color: #60a5fa;
}

.flow-card-node[data-node-type='documents'].active {
  border: 2px solid #0369a1 !important;
  box-shadow: 0 0 0 8px rgba(3, 105, 161, 0.35), 0 0 25px rgba(3, 105, 161, 0.6);
  animation: border-pulse-documents 2s ease-in-out infinite;
}

@keyframes border-pulse-documents {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(3, 105, 161, 0.35), 0 0 15px rgba(3, 105, 161, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(3, 105, 161, 0.45), 0 0 10px rgba(3, 105, 161, 0.8);
  }
}

/* Embedding Node - Teal/Cyan theme */
.flow-card-node[data-node-type='embedding'] {
  border: 2px solid #5eead4;
  box-shadow: 0 0 12px rgba(20, 184, 166, 0.6);
}

.flow-card-node[data-node-type='embedding']:hover {
  border-color: #2dd4bf;
}

.flow-card-node[data-node-type='embedding'].active {
  border: 2px solid #14b8a6 !important;
  box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 25px rgba(20, 184, 166, 0.6);
  animation: border-pulse-embedding 2s ease-in-out infinite;
}

@keyframes border-pulse-embedding {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 15px rgba(20, 184, 166, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(20, 184, 166, 0.45), 0 0 10px rgba(20, 184, 166, 0.8);
  }
}

/* Smart Intent Node - Indigo theme (matches FlowNode) */
.flow-card-node[data-node-type='smartIntent'] {
  border: 2px solid #6366f1;
  box-shadow: 0 0 12px rgba(79, 70, 229, 0.6);
}

.flow-card-node[data-node-type='smartIntent']:hover {
  border-color: #4f46e5;
}

.flow-card-node[data-node-type='smartIntent'].active {
  border: 2px solid #4f46e5 !important;
  box-shadow: 0 0 0 8px rgba(79, 70, 229, 0.35), 0 0 25px rgba(79, 70, 229, 0.6);
  animation: border-pulse-smartIntent 2s ease-in-out infinite;
}

@keyframes border-pulse-smartIntent {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(79, 70, 229, 0.35), 0 0 15px rgba(79, 70, 229, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(79, 70, 229, 0.45), 0 0 10px rgba(79, 70, 229, 0.8);
  }
}

/* Advanced Router Node - Purple theme (matches FlowNode) */
.flow-card-node[data-node-type='advancedRouter'] {
  border: 2px solid #8b5cf6;
  box-shadow: 0 0 12px rgba(139, 92, 246, 0.6);
}

.flow-card-node[data-node-type='advancedRouter']:hover {
  border-color: #7c3aed;
}

.flow-card-node[data-node-type='advancedRouter'].active {
  border: 2px solid #7c3aed !important;
  box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 25px rgba(139, 92, 246, 0.6);
  animation: border-pulse-advancedRouter 2s ease-in-out infinite;
}

@keyframes border-pulse-advancedRouter {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 15px rgba(139, 92, 246, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(139, 92, 246, 0.45), 0 0 10px rgba(139, 92, 246, 0.8);
  }
}

/* Merge Node - Cyan theme */
.flow-card-node[data-node-type='merge'] {
  border: 2px solid #06b6d4;
  box-shadow: 0 0 12px rgba(6, 182, 212, 0.6);
}

.flow-card-node[data-node-type='merge']:hover {
  border-color: #0891b2;
}

.flow-card-node[data-node-type='merge'].active {
  border: 2px solid #0891b2 !important;
  box-shadow: 0 0 0 8px rgba(6, 182, 212, 0.35), 0 0 25px rgba(6, 182, 212, 0.6);
  animation: border-pulse-merge 2s ease-in-out infinite;
}

@keyframes border-pulse-merge {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(6, 182, 212, 0.35), 0 0 15px rgba(6, 182, 212, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(6, 182, 212, 0.45), 0 0 10px rgba(6, 182, 212, 0.8);
  }
}

/* Node Header */
.node-header {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  background: transparent;
  border-bottom: none;
}

.node-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  flex-shrink: 0;
  background: #f3f4f6;
  color: #6b7280;
}

/* Node type-based icon colors */
.flow-node[data-node-type='messageInput'] .node-icon {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
}

.flow-node[data-node-type='intent'] .node-icon {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.25);
}

.flow-node[data-node-type='aiModel'] .node-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
}

.flow-node[data-node-type='queryRewriter'] .node-icon {
  background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(124, 58, 237, 0.3);
}

.flow-node[data-node-type='messageOutput'] .node-icon {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  color: white;
}

.node-info {
  flex: 1;
  min-width: 0;
}

.node-title {
  font-weight: 600;
  font-size: 11px;
  color: #51565f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  margin-bottom: 2px;
}

.node-subtitle {
  font-size: 9px;
  color: #6b7280;
  margin-top: 0;
  font-weight: 400;
}

.status-indicator {
  display: flex;
  align-items: center;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8);
}

/* Node Time Info */
.node-time-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: rgba(0, 0, 0, 0.02);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  gap: 8px;
}

.node-time {
  display: flex;
  align-items: center;
  font-size: 9px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
}

.node-duration {
  display: flex;
  align-items: center;
  font-size: 9px;
  color: white;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.click-indicator {
  position: absolute;
  bottom: 4px;
  right: 4px;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.flow-node:hover .click-indicator {
  opacity: 1;
}

/* Connection Arrow */
.horizontal-arrow {
  display: flex;
  align-items: center;
  margin: 0 8px;
  position: relative;
}

.arrow-icon {
  transition: all 0.3s ease;
  opacity: 0.7;
}

.arrow-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* =============================================================================
   CARD STYLE NODES (Intent, Model, InterestOptimizer)
   Based on FlowNode.vue styling
   ============================================================================= */
.flow-card-node {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  height: 120px;
  min-height: 120px;
  max-height: 120px;
  width: 210px;
  min-width: 210px;
  max-width: 210px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.flow-card-node:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18);
}

.flow-card-node.active {
  transform: translateY(-4px) scale(1.02);
}

/* Action Type Badge for Cards */
.action-type-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.action-type-badge.main-action {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.action-type-badge.parallel-action {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

/* Action Type Badge for Regular Nodes */
.action-type-badge-node {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 5px;
  border-radius: 6px;
  font-size: 7px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  z-index: 2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.action-type-badge-node.main-action {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.action-type-badge-node.parallel-action {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

/* Intent Card - Purple Theme */
.flow-card-node[data-node-type='intent'] {
  border: 2px solid #c0a4ff;
  box-shadow: 0 0 12px rgba(145, 27, 255, 0.6);
}

.flow-card-node[data-node-type='intent']:hover {
  border-color: #a984ff;
}

.flow-card-node[data-node-type='intent'].active {
  border: 2px solid #8b5cf6 !important;
  box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 25px rgba(139, 92, 246, 0.6);
  animation: border-pulse-intent 2s ease-in-out infinite;
}

@keyframes border-pulse-intent {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 15px rgba(139, 92, 246, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(139, 92, 246, 0.45), 0 0 10px rgba(139, 92, 246, 0.8);
  }
}

/* Query Rewriter Card - Purple Theme */
.flow-card-node[data-node-type='queryRewriter'] {
  border: 2px solid #a78bfa;
  box-shadow: 0 0 12px rgba(124, 58, 237, 0.6);
}

.flow-card-node[data-node-type='queryRewriter']:hover {
  border-color: #8b5cf6;
}

.flow-card-node[data-node-type='queryRewriter'].active {
  border: 2px solid #7c3aed !important;
  box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.35), 0 0 25px rgba(124, 58, 237, 0.6);
  animation: border-pulse-queryRewriter 2s ease-in-out infinite;
}

@keyframes border-pulse-queryRewriter {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.35), 0 0 15px rgba(124, 58, 237, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(124, 58, 237, 0.45), 0 0 10px rgba(124, 58, 237, 0.8);
  }
}

@keyframes border-pulse-queryrewriter {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.35), 0 0 15px rgba(124, 58, 237, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(124, 58, 237, 0.45), 0 0 10px rgba(124, 58, 237, 0.8);
  }
}

/* Model Card - Blue Theme */
.flow-card-node[data-node-type='model'] {
  border: 2px solid #8bb8ff;
  box-shadow: 0 0 12px rgba(11, 68, 255, 0.6);
  background: rgba(255, 255, 255, 0.95);
}

.flow-card-node[data-node-type='model'].active {
  border: 2px solid #3b82f6 !important;
  box-shadow: 0 0 0 8px rgba(59, 130, 246, 0.35), 0 0 25px rgba(59, 130, 246, 0.6);
  animation: border-pulse-model 2s ease-in-out infinite;
}

@keyframes border-pulse-model {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(59, 130, 246, 0.35), 0 0 15px rgba(59, 130, 246, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0.45), 0 0 10px rgba(59, 130, 246, 0.8);
  }
}

.flow-card-node[data-node-type='model']:hover {
  border-color: #5f92ff;
}

/* Interest Optimizer Card - Amber Theme */
.flow-card-node[data-node-type='interestOptimizer'] {
  border: 2px solid #fbbf24;
  box-shadow: 0 0 12px rgba(245, 158, 11, 0.6);
}

.flow-card-node[data-node-type='interestOptimizer']:hover {
  border-color: #f59e0b;
}

.flow-card-node[data-node-type='interestOptimizer'].active {
  border: 2px solid #f59e0b !important;
  box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.35), 0 0 25px rgba(245, 158, 11, 0.6);
  animation: border-pulse-optimizer 2s ease-in-out infinite;
}

@keyframes border-pulse-optimizer {

  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.35), 0 0 15px rgba(245, 158, 11, 0.6);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(245, 158, 11, 0.45), 0 0 10px rgba(245, 158, 11, 0.8);
  }
}

/* Card Header Section */
.card-header-section {
  padding: 10px 12px 8px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  background: transparent;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: transparent;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.card-info {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-subtitle {
  font-size: 10px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Card Time Info */
.card-time-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.02);
  gap: 8px;
}

.card-time {
  display: flex;
  align-items: center;
  font-size: 9px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
}

.card-duration {
  display: flex;
  align-items: center;
  font-size: 9px;
  background: white;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* =============================================================================
   END CARD STYLE NODES
   ============================================================================= */

/* Step Details Panel */
.step-details-panel {
  margin-top: 20px;
  padding-top: 20px;
  width: 100%;
  overflow: visible;
  flex-shrink: 0;
}

/* Instruction Panel */
.instruction-panel {
  margin-top: auto;
  padding-top: 20px;
  overflow: visible;
  flex-shrink: 0;
  display: flex;
}

.instruction-card {
  /* background: linear-gradient(135deg, rgba(25, 118, 210, 0.02), rgba(25, 118, 210, 0.05)) !important;
  border: 2px dashed rgba(25, 118, 210, 0.3) !important; */
  animation: fadeInUp 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: top center;
  border-radius: 16px;
  border: 2px dashed #3859D0;
  background: rgba(239, 244, 255, 0.50);
  width: 100%;
  padding: 24px;
}

.instruction-icon-wrapper {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }
}

.instruction-icon {
  opacity: 0.8;
}

.instruction-title {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 600;
  font-size: 1.5rem;
}

.instruction-subtitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 1rem;
  line-height: 1.5;
}

.instruction-hints {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

.details-card {
  animation: fadeInUp 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: top center;
  max-height: none;
  border-radius: 16px;
  border: 1px solid #C9C9C9;
  background: #FFF;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Smooth transition for details panel */
.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-fade-leave-active {
  transition: none;
  /* Instant fade out */
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-15px) scale(0.98);
}

.slide-fade-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-15px) scale(0.98);
}

/* Data Display Card Styles - Input/Output Data */
.data-section-label {
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 8px;
}

.data-display-card {
  position: relative;
  background: rgba(239, 244, 255, 0.25);
  border: 1px solid #EFF4FF;
  border-radius: 16px;
  padding: 16px;
  padding-right: 40px;
  min-height: 50px;
  max-height: 400px;
  overflow-y: auto;
}

/* Custom scrollbar for data-display-card */
.data-display-card::-webkit-scrollbar {
  width: 6px;
}

.data-display-card::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

.data-display-card::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.3);
  border-radius: 3px;
}

.data-display-card::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.5);
}

.data-content {
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.data-copy-btn {
  position: absolute;
  top: 12px;
  right: 12px;
}

.timing-details {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.timing-compact {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  padding: 5px 0 5px 0;
  border-radius: 6px;
}

.timing-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.timing-label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

.timing-value {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.duration-badge-compact {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: white;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  border: 1px solid #2ABF56;
}

.duration-label-compact {
  font-size: 9px;
  opacity: 0.9;
}

.duration-badge-inline {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  color: white;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.timing-details>div {
  margin-bottom: 4px;
  font-size: 12px;
}

/* Log References Section */
.log-refs-table-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.log-refs-table {
  font-size: 12px;
}

.log-refs-table thead tr th {
  background: #FFF2F2 !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 8px 12px !important;
}

.log-refs-table tbody tr.log-ref-row {
  transition: background-color 0.2s ease;
}

.log-refs-table tbody tr.log-ref-row:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}

.log-refs-table tbody tr td {
  padding: 10px 12px !important;
  font-size: 11px !important;
  border-bottom: 1px solid #f0f0f0 !important;
}

.token-info {
  display: flex;
  justify-content: center;
}

.ref-detail-grid {
  display: grid;
  gap: 12px;
  padding: 8px;
}

.detail-section {
  padding: 8px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 6px;
  font-size: 11px;
}

.detail-section strong {
  display: block;
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-code {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 8px;
  font-size: 10px;
  line-height: 1.4;
  max-height: 150px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Courier New', monospace;
  margin-top: 4px;
}

.log-refs-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 8px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.log-refs-ids {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.error-message {
  background: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 8px;
  color: #d32f2f;
  font-size: 13px;
  display: flex;
  align-items: center;
}

/* Scrollbar for horizontal flow */
.horizontal-flow-steps::-webkit-scrollbar {
  height: 6px;
}

.horizontal-flow-steps::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.horizontal-flow-steps::-webkit-scrollbar-thumb {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.horizontal-flow-steps::-webkit-scrollbar-thumb:hover {
  background: rgba(25, 118, 210, 0.5);
}

/* Responsive Design */
@media (max-width: 768px) {
  .horizontal-flow-steps {
    padding: 16px 0;
    gap: 12px;
  }

  /* Checkpoint Responsive */
  .checkpoint-node {
    min-width: 70px;
    max-width: 100px;
    padding: 6px;
  }

  .checkpoint-icon {
    width: 32px;
    height: 32px;
    margin-bottom: 6px;
  }

  .checkpoint-icon::before {
    width: 40px;
    height: 40px;
    top: -4px;
    left: -4px;
  }

  .checkpoint-label {
    font-size: 10px;
    margin-bottom: 3px;
  }

  .checkpoint-time {
    font-size: 8px;
  }

  /* Flow Node Responsive */
  .flow-node {
    min-width: 140px;
    max-width: 160px;
  }

  .node-header {
    padding: 8px 10px 6px 10px;
  }

  .node-content {
    padding: 0 10px 8px 10px;
  }

  .node-icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  .node-title {
    font-size: 11px;
  }

  .node-subtitle {
    font-size: 9px;
  }

  .time-label {
    font-size: 9px;
  }

  .duration-badge {
    font-size: 8px;
    padding: 1px 4px;
  }

  .log-count {
    font-size: 8px;
    padding: 1px 4px;
  }
}

/* Optimize dialog transitions */
.v-dialog {
  will-change: transform, opacity;
}

.v-dialog--active {
  animation: dialogFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes dialogFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.flow-dialog-header {
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  position: relative;
  overflow: hidden;
}

.flow-dialog-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  animation: shimmer 3s ease-in-out infinite; */
}

@keyframes shimmer {

  0%,
  100% {
    opacity: 0.3;
  }

  50% {
    opacity: 0.7;
  }
}

.flow-header-text {
  flex: 1;
}

.close-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
}

.close-btn i {
  color: white !important;
}

.flow-dialog-content {
  background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
  height: 70vh;
  min-height: 70vh;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  will-change: scroll-position;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

/* Scrollbar Styling */
.flow-dialog-content::-webkit-scrollbar {
  width: 8px;
}

.flow-dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.flow-dialog-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

.flow-dialog-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

/* =============================================================================
   MONITOR DIALOG STYLES
   ============================================================================= */
.monitor-content {
  padding: 8px 0;
}

.monitor-content-new {
  background: white !important;
}

.monitor-section {
  margin-bottom: 20px;
}

.monitor-section:last-child {
  margin-bottom: 0;
}

.monitor-textarea {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
}

.monitor-textarea :deep(.v-field__input) {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
  color: #333;
}

.monitor-textarea :deep(textarea) {
  font-family: 'Courier New', monospace !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
}

.monitor-json {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px;
  font-size: 11px;
  line-height: 1.5;
  max-height: 400px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Courier New', monospace;
  color: #333;
}

.monitor-json::-webkit-scrollbar {
  width: 6px;
}

.monitor-json::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.monitor-json::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.monitor-json::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Log Textarea Styles - Similar to Stream.vue */
.Log_text_textarea :deep(.v-field__input) {
  font-family: Poppins, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  padding: 12px;
  -webkit-mask-image: none !important;
  mask-image: none !important;
}

.Log_text_textarea :deep(textarea) {
  font-family: Poppins, sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 1.6 !important;
  color: #333333 !important;
}

.Log_text_textarea :deep(.v-field) {
  border-radius: 16px !important;
  background: rgba(239, 244, 255, 0.25) !important;
  border: 1px solid #EFF4FF !important;
}

.Log_text_textarea :deep(.v-field__overlay) {
  background: transparent !important;
}

.Log_text_textarea :deep(.v-field__outline) {
  display: none !important;
}

.Log_text_textarea :deep(.v-field--focused) {
  background-color: rgba(239, 244, 255, 0.4) !important;
  border-radius: 16px !important;
}

/* Monitor Dialog Styles */
.monitor-panels {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Inner cards inside monitor panels */
.monitor-card-content .v-card {
  background: transparent !important;
  box-shadow: none !important;
}

.monitor-expandable-card {
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff !important;
  box-shadow: unset !important;
}

.monitor-expandable-header {
  background: linear-gradient(90deg, #FFF2F2 0%, #FFDED8 100%);
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 16px;
  transition: all 0.3s ease;
  user-select: none;
}

.monitor-expandable-header-expanded {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  color: #FFFFFF !important;
}

.monitor-expandable-header:hover {
  background: linear-gradient(90deg, #FFE8E8 0%, #FFD0C8 100%);
}

.monitor-expandable-header:focus {
  outline-offset: 2px;
}

.monitor-expandable-header .header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.monitor-card-content {
  background: transparent !important;
  box-shadow: unset !important;
  margin-top: 5px;
  border-radius: 16px !important;
  padding: 5px !important;
}

/* Override Vuetify's default card styling inside monitor panels */
.monitor-card-content :deep(.v-card) {
  background: #ffffff !important;
  box-shadow: none !important;
}

.monitor-card-content :deep(.v-card-subtitle) {
  background: transparent !important;
  opacity: 1 !important;
}

.monitor-card-content :deep(.v-card-text) {
  background: transparent !important;
}

.monitor-card-content :deep(.v-card--variant-outlined) {
  background: #ffffff !important;
  border: 1px solid #E0E0E0 !important;
}

.monitor-dialog-expand-card {
  border-radius: 16px;
  border: 1px solid #C9C9C9;
}

.icon-white-filter {
  filter: brightness(0) invert(1);
}

.text-white {
  color: #ffffff !important;
}

/* AI Attempts Table Styles */
.ai-attempts-table thead {
  background: rgba(195, 46, 14, 0.08);
}

.ai-attempts-table thead th {
  font-weight: 600;
  font-size: 0.85rem;
  color: rgba(15, 23, 42, 0.8);
}

.ai-attempts-table tbody tr {
  min-height: 60px;
  height: 60px;
}

.ai-attempts-table tbody tr td {
  vertical-align: middle;
  font-size: 0.9rem;
}

.endpoint-text.clickable-text {
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px 8px;
  border-radius: 6px;
}

.endpoint-text.clickable-text:hover {
  background-color: rgba(195, 46, 14, 0.08);
  color: #C32E0E;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-label {
  font-family: Poppins, sans-serif !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  color: #646464;
  text-transform: none;
  letter-spacing: normal;
  margin-top: 8px;
}

.info-card {
  background: #FFF;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid #C9C9C9;
}

.param-label {
  font-size: 11px;
  color: #666;
  margin-bottom: 2px;
}

.param-value {
  font-size: 12px;
  font-weight: 500;
  color: #2c3e50;
}

/* =============================================================================
   PROFESSIONAL TOAST NOTIFICATION
   ============================================================================= */
:deep(.professional-toast) {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05) !important;
  backdrop-filter: blur(10px);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  padding: 8px 12px !important;
  min-height: auto !important;
}

:deep(.professional-toast .swal2-title) {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  margin-bottom: 2px !important;
  line-height: 1.2 !important;
}

:deep(.professional-toast .swal2-html-container) {
  font-size: 11px !important;
  color: #64748b !important;
  margin: 0 !important;
  font-weight: 400 !important;
  line-height: 1.3 !important;
}

:deep(.professional-toast .swal2-icon) {
  width: 24px !important;
  height: 24px !important;
  margin: 0 10px 0 0 !important;
  border-width: 2px !important;
}

:deep(.professional-toast .swal2-icon.swal2-success) {
  border-color: #10b981 !important;
}

:deep(.professional-toast .swal2-success-ring) {
  border: 2px solid rgba(16, 185, 129, 0.3) !important;
}

:deep(.professional-toast .swal2-success-line-tip),
:deep(.professional-toast .swal2-success-line-long) {
  background-color: #10b981 !important;
}

/* Remove default animation */
:deep(.swal2-noanimation) {
  animation: slideInRight 0.2s ease-out !important;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.used-status-pill {
  height: 10px;
  width: 40px;
  padding: 0;
}
.divider{
  border-left: 2px solid #E0E0E0;
  margin-top: 15px;
  height: 50px;
}
/* Clear All Filters Button - New Style */
.clear-filters-btn-new {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 10px;
  background: transparent;
  border: 1px solid #3859D0;
  color: #3859D0;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  justify-content: center;
}

.clear-filters-btn-new:hover {
  background: rgba(56, 89, 208, 0.1);
  transform: translateY(-1px);
}

/* Search Button Inside Advanced Filters */
.search-btn-new {
  display: flex;
  min-width: 120px;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%);
  color: #ffffff;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.search-btn-new:hover {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%);
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(195, 46, 14, 0.3);
}

.reportdata-filter-title{
  color: var(--Main-Text, #171717);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.advanced-filters-row{
  border-radius: 16px;
  background: rgba(239, 244, 255, 0.50);
  padding: 16px;
}
</style>
